import { InputHandler } from '../utils/Input.js';
import ThemeManager from './ThemeManager.js';
import AuthManager from './AuthManager.js';
import LeaderboardManager from './LeaderboardManager.js';
import ChallengeManager from './ChallengeManager_New.js';
import I18nManager from './I18nManager.js';
import TutorialManager from './TutorialManager.js';
import { Icons } from '../utils/Icons.js';
import TapGame from '../microgames/TapGame.js';
import SwipeGame from '../microgames/SwipeGame.js';
import DontMoveGame from '../microgames/DontMoveGame.js';
import MazeGame from '../microgames/MazeGame.js';
import SoccerGame from '../microgames/SoccerGame.js';
import HoldGame from '../microgames/HoldGame.js';
import ShakeGame from '../microgames/ShakeGame.js';
import ChargeGame from '../microgames/ChargeGame.js';
import DodgeGame from '../microgames/DodgeGame.js';
import MatchGame from '../microgames/MatchGame.js';
import TypeGame from '../microgames/TypeGame.js';
import SpinGame from '../microgames/SpinGame.js';
import CatchGame from '../microgames/CatchGame.js';
import CountGame from '../microgames/CountGame.js';
import FindGame from '../microgames/FindGame.js';
import ConnectGame from '../microgames/ConnectGame.js';
import PumpGame from '../microgames/PumpGame.js';
import SliceGame from '../microgames/SliceGame.js';
import UnlockGame from '../microgames/UnlockGame.js';
import SortGame from '../microgames/SortGame.js';
import StopwatchGame from '../microgames/StopwatchGame.js';
import WhackGame from '../microgames/WhackGame.js';
import DefendGame from '../microgames/DefendGame.js';
import BalanceGame from '../microgames/BalanceGame.js';
import AlignGame from '../microgames/AlignGame.js';
import FillGame from '../microgames/FillGame.js';
import StackGame from '../microgames/StackGame.js';
import CleanGame from '../microgames/CleanGame.js';
import CrackGame from '../microgames/CrackGame.js';
import TraceGame from '../microgames/TraceGame.js';
import DodgeVerticalGame from '../microgames/DodgeVerticalGame.js';
import SimonGame from '../microgames/SimonGame.js';
import MathGame from '../microgames/MathGame.js';
import ShootGame from '../microgames/ShootGame.js';
import FanGame from '../microgames/FanGame.js';
import OrderGame from '../microgames/OrderGame.js';
import JumpGame from '../microgames/JumpGame.js';
import DuckGame from '../microgames/DuckGame.js';
import ReelGame from '../microgames/ReelGame.js';
import ShaveGame from '../microgames/ShaveGame.js';
import PetGame from '../microgames/PetGame.js';
import ToastGame from '../microgames/ToastGame.js';
import AnswerGame from '../microgames/AnswerGame.js';
import HighFiveGame from '../microgames/HighFiveGame.js';
import DrinkGame from '../microgames/DrinkGame.js';
import BlowGame from '../microgames/BlowGame.js';
import ScratchGame from '../microgames/ScratchGame.js';
import SquashGame from '../microgames/SquashGame.js';
import GolfGame from '../microgames/GolfGame.js';
import BowlingGame from '../microgames/BowlingGame.js';
import ArcheryGame from '../microgames/ArcheryGame.js';
import SnatchGame from '../microgames/SnatchGame.js';
import SafeCrackGame from '../microgames/SafeCrackGame.js';
import MorseGame from '../microgames/MorseGame.js';
import MergeGame from '../microgames/MergeGame.js';
import PeelGame from '../microgames/PeelGame.js';
import ScaleGame from '../microgames/ScaleGame.js';
import TugGame from '../microgames/TugGame.js';
import ParkGame from '../microgames/ParkGame.js';
import FlySwatGame from '../microgames/FlySwatGame.js';
import BasketGame from '../microgames/BasketGame.js';
import TrafficGame from '../microgames/TrafficGame.js';
import UmbrellaGame from '../microgames/UmbrellaGame.js';
import FlipGame from '../microgames/FlipGame.js';
import SawGame from '../microgames/SawGame.js';
import TankGame from '../microgames/TankGame.js';
import ZipperGame from '../microgames/ZipperGame.js';
import NeedleGame from '../microgames/NeedleGame.js';
import PizzaGame from '../microgames/PizzaGame.js';
import PlugGame from '../microgames/PlugGame.js';
import UnscrewGame from '../microgames/UnscrewGame.js';
import RipGame from '../microgames/RipGame.js';
import SprayGame from '../microgames/SprayGame.js';
import TunerGame from '../microgames/TunerGame.js';
import FileGame from '../microgames/FileGame.js';
import IgniteGame from '../microgames/IgniteGame.js';
import CrushGame from '../microgames/CrushGame.js';
import StampGame from '../microgames/StampGame.js';
import ShredGame from '../microgames/ShredGame.js';
import FlickGame from '../microgames/FlickGame.js';
import DunkGame from '../microgames/DunkGame.js';
import SpreadGame from '../microgames/SpreadGame.js';
import UnrollGame from '../microgames/UnrollGame.js';
import PokeGame from '../microgames/PokeGame.js';
import FishGame from '../microgames/FishGame.js';
import SkateGame from '../microgames/SkateGame.js';
import KiteGame from '../microgames/KiteGame.js';
import PingPongGame from '../microgames/PingPongGame.js';
import PlantGame from '../microgames/PlantGame.js';
import PianoGame from '../microgames/PianoGame.js';
import PoolGame from '../microgames/PoolGame.js';
import DartGame from '../microgames/DartGame.js';
import CardGame from '../microgames/CardGame.js';
import PhotoGame from '../microgames/PhotoGame.js';
import OrbitGame from '../microgames/OrbitGame.js';
import MagnetGame from '../microgames/MagnetGame.js';
import RopeGame from '../microgames/RopeGame.js';
import ReactionGame from '../microgames/ReactionGame.js';
import KeepUpGame from '../microgames/KeepUpGame.js';
import SpaceGame from '../microgames/SpaceGame.js';
import AdminPanel from './AdminPanel.js';
import { BLOB_INVENTORY_KEY, BLOB_SHOP_ITEMS } from '../data/blobShopCatalog.js';

export default class GameEngine {
    constructor() {
        console.log("GameEngine v3.57 (User Switch Fix)");
        this.i18n = new I18nManager();

        // --- MULTIPLICATEUR DE VITESSE (DEBUG) ---
        // Change ici pour démarrer tous les jeux à haute vitesse (ex: 4.0). Remets à 1.0 pour jouer normalement.
        this.STARTING_SPEED_MULTIPLIER = 1.0;
        // -----------------------------------------

        this.container = document.getElementById('game-layer');
        this.ui = {
            menu: document.getElementById('main-menu'),
            gameover: document.getElementById('game-over'),
            transition: document.getElementById('transition-screen'),
            hud: document.getElementById('hud'),
            score: document.getElementById('score'),
            lives: document.getElementById('lives'),
            timerFill: document.getElementById('timer-fill'),
            instruction: document.getElementById('instruction-text'),
            finalScore: document.getElementById('final-score'),
            gamesGrid: document.getElementById('games-grid'),
            allGames: document.getElementById('all-games-screen'),
            allGamesSearch: document.getElementById('all-games-search'),
            userDisplay: document.getElementById('user-display'),
            // Auth Screens
            loginScreen: document.getElementById('login-screen'),
            loginEmailInput: document.getElementById('login-email-input'),
            loginPassInput: document.getElementById('login-password-input'),
            loginMessage: document.getElementById('login-message'),
            forgotPasswordScreen: document.getElementById('forgot-password-screen'),
            forgotEmailInput: document.getElementById('forgot-email-input'),
            resetPasswordScreen: document.getElementById('reset-password-screen'),
            resetPasswordInput: document.getElementById('reset-password-input'),
            resetConfirmInput: document.getElementById('reset-confirm-input'),
            registerScreen: document.getElementById('register-screen'),
            convertScreen: document.getElementById('convert-guest-screen'),
            // Profile UI
            profileScreen: document.getElementById('profile-screen'),
            profileLevel: document.getElementById('profile-level'),
            profileXpText: document.getElementById('profile-xp-text'),
            profileXpFill: document.getElementById('profile-xp-fill'),
            profileTotalCoins: document.getElementById('profile-total-coins'),
            profileUnlockedCount: document.getElementById('profile-unlocked-count'),
            // Menu XP & Level
            menuLevelDisplay: document.getElementById('menu-level-display'),
            menuXpFill: document.getElementById('menu-xp-fill'),
            menuCoinsDisplay: document.getElementById('menu-coins-display'),
            menuEnergyDisplay: document.getElementById('menu-energy-display'),
            shopCoinsDisplay: document.getElementById('shop-coins-display'),
            coinsDisplay: document.getElementById('hud-coins'),
            // Revive UI
            reviveOverlay: document.getElementById('revive-overlay'),
            reviveCost: document.getElementById('revive-cost'),
            reviveBtn: document.getElementById('revive-btn'),
            reviveBtn: document.getElementById('revive-btn'),
            cancelReviveBtn: document.getElementById('cancel-revive-btn'),
            // Confirm UI
            confirmOverlay: document.getElementById('confirm-overlay'),
            confirmMessage: document.getElementById('confirm-message'),
            confirmYes: document.getElementById('confirm-yes-btn'),
            confirmNo: document.getElementById('confirm-no-btn'),
            // Friends UI
            friendsScreen: document.getElementById('friends-screen'),
            friendsList: document.getElementById('friends-list'),
            friendsMenuBtn: document.getElementById('friends-menu-btn'),
            addFriendInput: document.getElementById('add-friend-input'),
            addFriendBtn: document.getElementById('add-friend-btn'),
            addFriendMsg: document.getElementById('add-friend-msg'),
            friendsBackBtn: document.getElementById('friends-back-btn'),
            myFriendCode: document.getElementById('my-friend-code'),
            shareBtn: document.getElementById('share-btn'),
            // Challenge UI
            challengeScreen: document.getElementById('challenge-screen'),

            // Overlays
            hud: document.getElementById('hud'),
            challengeList: document.getElementById('challenge-list')
        };

        this.languageSelect = document.getElementById('language-select');
        if (this.languageSelect) {
            this.languageSelect.value = this.i18n.getLanguage();
            this.languageSelect.addEventListener('change', async (e) => {
                this.i18n.setLanguage(e.target.value);
                this.refreshLocalizedTexts();
                await this.reloadProfileScreenAfterLanguageChange();
            });
        }
        this.i18n.applyDomTranslations();
        this.i18n.observeInstruction(this.ui.instruction);

        this.input = new InputHandler(document.body);

        this.themeManager = new ThemeManager(this);
        this.authManager = new AuthManager(this);
        this.leaderboardManager = new LeaderboardManager(this);
        this.tutorialManager = new TutorialManager(this);
        this.challengeManager = new ChallengeManager(this);
        this.adminPanel = new AdminPanel(this);
        this.adminPanel.init();
        window._adminPanel = this.adminPanel;

        this.gameMode = 'STANDARD';
        this.state = 'MENU';
        this.pendingPasswordResetToken = null;
        this.score = 0;
        this.lives = 4;
        this.speedMultiplier = 1.0;

        this.currentMicrogame = null;
        this.timer = 0;
        this.maxTime = 3000;

        this.lastFrameTime = 0;
        this.transitionTimeout = null;
        this.nextGameClass = null;

        // Deck System & Speed Cap
        this.gameDeck = [];
        this.maxSpeed = 4.0; // Max Speed Multiplier
        this._lastMicrogameClass = null;

        // Time Scoring
        this.startTime = 0;
        this.elapsedTime = 0;
        this.scoreAccumulator = 0;

        // Define Games List Dynamically
        this.gamesList = [
            { class: TapGame, weight: 3, action: "TAP!", name: "Tap" },
            { class: SwipeGame, weight: 3, action: "SWIPE!", name: "Swipe" },
            { class: MazeGame, weight: 3, action: "ESCAPE!", name: "Maze" },
            { class: SoccerGame, weight: 3, action: "SHOOT!", name: "Soccer" },
            { class: HoldGame, weight: 3, action: "HOLD!", name: "Hold" },
            { class: ShakeGame, weight: 3, action: "SHAKE!", name: "Shake" },
            { class: ChargeGame, weight: 3, action: "CHARGE!", name: "Charge" },
            { class: DodgeGame, weight: 3, action: "DODGE!", name: "Dodge" },
            { class: MatchGame, weight: 3, action: "MATCH!", name: "Match" },
            { class: TypeGame, weight: 3, action: "TYPE!", name: "Type" },
            { class: SpinGame, weight: 3, action: "SPIN!", name: "Spin" },
            { class: CatchGame, weight: 3, action: "CATCH!", name: "Catch" },
            { class: CountGame, weight: 3, action: "COUNT!", name: "Count" },
            { class: FindGame, weight: 3, action: "FIND!", name: "Find" },
            { class: ConnectGame, weight: 3, action: "CONNECT!", name: "Connect" },
            { class: DontMoveGame, weight: 1, action: "DON'T MOVE!", name: "Don't Move" },
            // Batch 1
            { class: PumpGame, weight: 3, action: "PUMP!", name: "Pump" },
            { class: SliceGame, weight: 3, action: "SLICE!", name: "Slice" },
            { class: UnlockGame, weight: 3, action: "UNLOCK!", name: "Unlock" },
            { class: SortGame, weight: 3, action: "SORT!", name: "Sort" },
            { class: StopwatchGame, weight: 3, action: "STOP AT 0!", name: "Stopwatch" },
            // Batch 2
            { class: WhackGame, weight: 3, action: "WHACK!", name: "Whack" },
            { class: DefendGame, weight: 3, action: "DEFEND!", name: "Defend" },
            { class: BalanceGame, weight: 3, action: "BALANCE!", name: "Balance" },
            { class: AlignGame, weight: 3, action: "ALIGN!", name: "Align" },
            { class: FillGame, weight: 3, action: "FILL!", name: "Fill" },
            // Batch 3
            { class: StackGame, weight: 3, action: "STACK!", name: "Stack" },
            { class: CleanGame, weight: 3, action: "CLEAN!", name: "Clean" },
            { class: CrackGame, weight: 3, action: "CRACK!", name: "Crack" },
            { class: TraceGame, weight: 3, action: "TRACE!", name: "Trace" },
            { class: DodgeVerticalGame, weight: 3, action: "DIVE!", name: "Dive" },

            // Batch 4
            { class: SimonGame, weight: 3, action: "REPEAT!", name: "Simon" },
            { class: MathGame, weight: 3, action: "SOLVE!", name: "Math" },
            { class: ShootGame, weight: 3, action: "SHOOT!", name: "Shoot" },
            { class: FanGame, weight: 3, action: "COOL!", name: "Fan" },
            { class: OrderGame, weight: 3, action: "1-2-3!", name: "Order" },

            // Batch 5
            { class: JumpGame, weight: 3, action: "JUMP!", name: "Jump" },
            { class: DuckGame, weight: 3, action: "DUCK!", name: "Duck" },
            { class: ReelGame, weight: 3, action: "REEL!", name: "Reel" },
            { class: ShaveGame, weight: 3, action: "SCRUB!", name: "Shave" },
            { class: PetGame, weight: 3, action: "SOOTHE!", name: "Pet" },
            { class: ToastGame, weight: 3, action: "CATCH!", name: "Toast" },
            { class: AnswerGame, weight: 3, action: "ANSWER!", name: "Answer" },
            { class: HighFiveGame, weight: 3, action: "SYNC!", name: "High Five" },
            { class: DrinkGame, weight: 3, action: "DRINK!", name: "Drink" },
            { class: BlowGame, weight: 3, action: "COOL!", name: "Blow" },
            { class: ScratchGame, weight: 3, action: "DECRYPT!", name: "Scratch" },
            { class: SquashGame, weight: 3, action: "SQUASH!", name: "Squash" },
            { class: GolfGame, weight: 3, action: "PUTT!", name: "Golf" },
            { class: BowlingGame, weight: 3, action: "STRIKE!", name: "Bowling" },
            { class: ArcheryGame, weight: 3, action: "SHOOT!", name: "Archery" },
            { class: SnatchGame, weight: 3, action: "GRAB!", name: "Snatch" },
            { class: SafeCrackGame, weight: 3, action: "CRACK!", name: "SafeCrack" },
            { class: MorseGame, weight: 3, action: "TAP!", name: "Morse" },
            { class: MergeGame, weight: 3, action: "MERGE!", name: "Merge" },
            { class: PeelGame, weight: 3, action: "PEEL!", name: "Peel" },
            { class: ScaleGame, weight: 3, action: "BALANCE!", name: "Scale" },
            { class: TugGame, weight: 3, action: "TUG!", name: "Tug" },
            { class: ParkGame, weight: 3, action: "PARK!", name: "Park" },
            { class: FlySwatGame, weight: 3, action: "SWAT!", name: "FlySwat" },
            { class: BasketGame, weight: 3, action: "SHOOT!", name: "Basket" },
            { class: TrafficGame, weight: 3, action: "CROSS!", name: "Traffic" },
            { class: UmbrellaGame, weight: 3, action: "OPEN!", name: "Umbrella" },
            { class: FlipGame, weight: 3, action: "FLIP!", name: "Flip" },
            { class: SawGame, weight: 3, action: "SAW!", name: "Saw" },
            { class: TankGame, weight: 3, action: "DESTROY!", name: "Tank" },
            // Batch 8
            { class: ZipperGame, weight: 3, action: "ZIP!", name: "Zipper" },
            { class: NeedleGame, weight: 3, action: "THREAD!", name: "Needle" },
            { class: PizzaGame, weight: 3, action: "TOPPINGS!", name: "Pizza" },
            { class: PlugGame, weight: 3, action: "PLUG IN!", name: "Plug" },
            // Batch 9
            { class: UnscrewGame, weight: 3, action: "UNSCREW!", name: "Unscrew" },
            { class: RipGame, weight: 3, action: "RIP!", name: "Rip" },
            { class: SprayGame, weight: 3, action: "SPRAY!", name: "Spray" },
            { class: TunerGame, weight: 3, action: "TUNE!", name: "Tuner" },
            { class: FileGame, weight: 3, action: "FILE!", name: "File" },
            // Batch 10
            { class: IgniteGame, weight: 3, action: "STRIKE!", name: "Ignite" },
            { class: CrushGame, weight: 3, action: "CRUSH!", name: "Crush" },
            { class: StampGame, weight: 3, action: "STAMP!", name: "Stamp" },
            { class: ShredGame, weight: 3, action: "SHRED!", name: "Shred" },
            // Batch 11
            { class: FlickGame, weight: 3, action: "FLICK!", name: "Flick" },
            { class: DunkGame, weight: 3, action: "DUNK!", name: "Dunk" },
            { class: SpreadGame, weight: 3, action: "SPREAD!", name: "Spread" },
            { class: UnrollGame, weight: 3, action: "UNROLL!", name: "Unroll" },
            { class: PokeGame, weight: 3, action: "POKE!", name: "Poke" },
            // Batch 12
            { class: FishGame, weight: 3, action: "CATCH!", name: "Fish" },
            { class: SkateGame, weight: 3, action: "JUMP!", name: "Skate" },
            { class: KiteGame, weight: 3, action: "FLY!", name: "Kite" },
            { class: PingPongGame, weight: 3, action: "RETURN!", name: "PingPong" },
            { class: PlantGame, weight: 3, action: "WATER!", name: "Plant" },
            { class: PianoGame, weight: 3, action: "PIANO!", name: "Piano" },
            { class: PoolGame, weight: 3, action: "POOL!", name: "Pool" },
            { class: DartGame, weight: 3, action: "THROW!", name: "Dart" },
            { class: CardGame, weight: 3, action: "PLAY!", name: "Card" },
            { class: PhotoGame, weight: 3, action: "TAKE!", name: "Photo" },
            // Batch 14 (Final)
            { class: OrbitGame, weight: 3, action: "ALIGN!", name: "Orbit" },
            { class: MagnetGame, weight: 3, action: "COLLECT!", name: "Magnet" },
            { class: RopeGame, weight: 3, action: "JUMP!", name: "Rope" },
            { class: ReactionGame, weight: 3, action: "WAIT... TAP!", name: "Reaction" },
            { class: KeepUpGame, weight: 3, action: "DONT DROP!", name: "Keep Up" },
            { class: SpaceGame, weight: 3, action: "PILOT!", name: "Space" }
        ];

        // --- MENU NAVIGATION LISTENERS ---

        // Play Button
        const startBtn = document.getElementById('start-btn');
        if (startBtn) {
            startBtn.onclick = (e) => {
                e.preventDefault();
                e.stopPropagation();

                const menu = document.getElementById('main-menu');
                const playMode = document.getElementById('play-mode-screen');

                if (menu) {
                    menu.classList.add('hidden');
                    menu.classList.remove('active');
                }

                if (playMode) {
                    playMode.classList.remove('hidden');
                    playMode.classList.add('active');
                }
            };
        } else {
            console.error("Start Button Not Found");
        }

        // Back from Play Mode
        const playModeBackBtn = document.getElementById('play-mode-back-btn');
        if (playModeBackBtn) {
            playModeBackBtn.addEventListener('click', () => {
                document.getElementById('play-mode-screen').classList.add('hidden');
                this.ui.menu.classList.remove('hidden');
            });
        }

        document.getElementById('restart-btn').addEventListener('click', () => this.resetGame());

        const goQuitBtn = document.getElementById('gameover-quit-btn');
        if (goQuitBtn) goQuitBtn.addEventListener('click', () => this.quitGame());

        // OLD ALL GAMES BUTTON REMOVED
        // document.getElementById('all-games-btn').addEventListener('click', () => this.showAllGames());

        document.getElementById('back-btn').addEventListener('click', () => this.hideAllGames());

        // Search Listener
        if (this.ui.allGamesSearch) {
            this.ui.allGamesSearch.addEventListener('input', (e) => this.filterAllGames(e.target.value));
        }

        if (this.ui.shareBtn) this.ui.shareBtn.addEventListener('click', () => this.handleShare());

        if (this.ui.reviveBtn) this.ui.reviveBtn.addEventListener('click', () => this.attemptRevive());
        if (this.ui.cancelReviveBtn) this.ui.cancelReviveBtn.addEventListener('click', () => this.cancelRevive());

        this.quitBtn = document.getElementById('quit-btn');
        this.quitBtn.addEventListener('click', () => this.quitGame());

        // Friends Menu Listeners
        if (this.ui.friendsMenuBtn) this.ui.friendsMenuBtn.addEventListener('click', () => this.showFriendsMenu());
        if (this.ui.friendsBackBtn) this.ui.friendsBackBtn.addEventListener('click', () => this.showMainMenu());
        if (this.ui.addFriendBtn) this.ui.addFriendBtn.addEventListener('click', () => this.handleAddFriend());
        if (this.ui.myFriendCode) {
            this.ui.myFriendCode.addEventListener('click', () => {
                const code = this.ui.myFriendCode.textContent;
                if (code && code !== '------') {
                    if (navigator.clipboard) {
                        navigator.clipboard.writeText(code).then(() => this.showNotification("Code copied!"));
                    } else {
                        // Fallback for insecure origin
                        const ta = document.createElement('textarea');
                        ta.value = code;
                        document.body.appendChild(ta);
                        ta.select();
                        document.execCommand('copy');
                        document.body.removeChild(ta);
                        this.showNotification("Code copied!");
                    }
                }
            });
        }

        // Theme Manager
        this.themeManager = new ThemeManager();
        this.ui.skinsScreen = document.getElementById('skins-screen');
        this.ui.skinsGrid = document.getElementById('skins-grid');
        this.ui.skinsGridEffects = document.getElementById('skins-grid-effects');
        this.ui.tabColors = document.getElementById('tab-colors');
        this.ui.tabEffects = document.getElementById('tab-effects');

        this.currentSkinsTab = 'colors'; // Default tab

        document.getElementById('skins-btn').addEventListener('click', () => this.showSkinsMenu());
        document.getElementById('skins-back-btn').addEventListener('click', () => this.hideSkinsMenu());

        this.ui.tabCoins = document.getElementById('tab-coins');
        this.ui.skinsGridCoins = document.getElementById('skins-grid-coins');

        this.ui.tabColors.addEventListener('click', () => this.switchSkinsTab('colors'));
        this.ui.tabEffects.addEventListener('click', () => this.switchSkinsTab('effects'));
        this.ui.tabCoins.addEventListener('click', () => this.switchSkinsTab('coins'));

        // Leaderboard Manager
        document.getElementById('leaderboard-btn').addEventListener('click', () => this.leaderboardManager.showMenu(this.gamesList));
        const pixelBlobBtn = document.getElementById('pixelblob-play-btn');
        if (pixelBlobBtn) pixelBlobBtn.addEventListener('click', () => this.showPixelBlobCreateScreen());
        const pixelBlobCreateBtn = document.getElementById('pixelblob-create-btn');
        if (pixelBlobCreateBtn) {
            pixelBlobCreateBtn.addEventListener('click', () => {
                const nameInput = document.getElementById('pixelblob-name-input');
                const colorInput = document.getElementById('pixelblob-color-input');
                const blobName = nameInput && nameInput.value ? nameInput.value.trim() : 'Blobette';
                const colorValue = colorInput && colorInput.value ? colorInput.value : '#baa98f';
                this.showPixelBlobScreen({ blobName, baseColorHex: parseInt(colorValue.replace('#', ''), 16) });
            });
        }
        const pixelBlobCreateBackBtn = document.getElementById('pixelblob-create-back-btn');
        if (pixelBlobCreateBackBtn) pixelBlobCreateBackBtn.addEventListener('click', () => this.showPlayModeScreen());
        const pixelBlobBackBtn = document.getElementById('pixelblob-back-btn');
        if (pixelBlobBackBtn) pixelBlobBackBtn.addEventListener('click', () => this.hidePixelBlobScreen());
        document.getElementById('profile-btn').addEventListener('click', () => this.showProfile());
        document.getElementById('profile-back-btn').addEventListener('click', () => this.showMainMenu());

        // Auth Manager Init
        this.authManager.init();

        // Login Listeners
        document.getElementById('login-btn').addEventListener('click', () => this.handleLogin());
        document.getElementById('show-register-btn').addEventListener('click', () => this.showRegisterScreen());
        document.getElementById('forgot-password-link').addEventListener('click', () => this.showForgotPasswordScreen());
        document.getElementById('login-to-guest-link').addEventListener('click', () => this.authManager.registerGuest());
        document.getElementById('send-reset-link-btn').addEventListener('click', () => this.handleForgotPassword());
        document.getElementById('forgot-back-btn').addEventListener('click', () => this.showLoginScreen());
        document.getElementById('do-reset-password-btn').addEventListener('click', () => this.handleResetPassword());
        document.getElementById('reset-back-btn').addEventListener('click', () => this.showLoginScreen());
        
        // Register Listeners
        document.getElementById('do-register-btn').addEventListener('click', () => this.handleRegister());
        document.getElementById('register-back-btn').addEventListener('click', () => this.showLoginScreen());

        // Convert Listeners
        document.getElementById('do-convert-btn').addEventListener('click', () => this.handleConvertGuest());
        document.getElementById('convert-back-btn').addEventListener('click', () => this.showMainMenu());

        document.getElementById('logout-btn').addEventListener('click', () => {
            this.authManager.logout();
            this.challengeManager.onUserChanged();
            this._notificationsChecked = false; // Reset notifications check
            this.showLoginScreen(); // Ensure we go back to login
        });

        // Admin Button
        const adminBtn = document.getElementById('admin-btn');
        if (adminBtn) {
            adminBtn.addEventListener('click', () => this.adminPanel.show());
        }

        this.initCookieBanner();
    }

    initCookieBanner() {
        const banner = document.getElementById('cookie-banner');
        if (banner) {
            banner.style.zIndex = "2147483647";
        }

        const acceptBtn = document.getElementById('accept-cookies');
        const refuseBtn = document.getElementById('refuse-cookies');

        if (!banner || !acceptBtn || !refuseBtn) return;

        if (localStorage.getItem('pixelblob_cookies_accepted') === null && localStorage.getItem('quicky_cookies_accepted') === null) {
            banner.style.display = 'block';
        } else {
            banner.style.display = 'none';
        }

        acceptBtn.addEventListener('click', () => {
            console.log('Cookies Accepted');
            localStorage.setItem('pixelblob_cookies_accepted', 'true');
            localStorage.setItem('quicky_cookies_accepted', 'true');
            banner.style.display = 'none';
        });

        refuseBtn.addEventListener('click', () => {
            console.log('Cookies Refused');
            localStorage.setItem('pixelblob_cookies_accepted', 'false');
            localStorage.setItem('quicky_cookies_accepted', 'false');
            banner.style.display = 'none';
        });
    }

    async handleLogin() {
        const email = this.ui.loginEmailInput.value;
        const password = this.ui.loginPassInput.value;

        if (!email || !password) {
            this.showLoginMessage(this.i18n.t('errors.loginRequiredFields'));
            return;
        }

        const result = await this.authManager.login(email, password);
        if (result.success) {
            this.showMainMenu();
            if (this._notificationsChecked === false) this.checkAdminNotifications();
        } else {
            this.showLoginMessage(result.message);
        }
    }

    async handleForgotPassword() {
        const email = (this.ui.forgotEmailInput.value || this.ui.loginEmailInput.value || '').trim();

        if (!email) {
            this.showAuthMessage('forgot', this.i18n.t('errors.emailRequired'));
            return;
        }

        const result = await this.authManager.requestPasswordReset(email);
        this.showAuthMessage('forgot', result.message);
        if (result.success) {
            this.ui.forgotEmailInput.value = '';
        }
    }

    async handleResetPassword() {
        const password = this.ui.resetPasswordInput.value;
        const confirm = this.ui.resetConfirmInput.value;

        if (!this.pendingPasswordResetToken) {
            this.showAuthMessage('reset', this.i18n.t('errors.invalidResetLink'));
            return;
        }

        if (!password || !confirm) {
            this.showAuthMessage('reset', this.i18n.t('errors.allFieldsRequired'));
            return;
        }

        if (password !== confirm) {
            this.showAuthMessage('reset', this.i18n.t('errors.passwordMismatch'));
            return;
        }

        const result = await this.authManager.resetPassword(this.pendingPasswordResetToken, password);
        if (result.success) {
            this.pendingPasswordResetToken = null;
            this.ui.resetPasswordInput.value = '';
            this.ui.resetConfirmInput.value = '';
            window.history.replaceState({}, document.title, window.location.pathname);
            this.showLoginScreen();
            this.showLoginMessage(result.message);
        } else {
            this.showAuthMessage('reset', result.message);
        }
    }

    async handleRegister() {
        const email = document.getElementById('register-email-input').value;
        const username = document.getElementById('register-username-input').value;
        const password = document.getElementById('register-password-input').value;
        const confirm = document.getElementById('register-confirm-input').value;

        if (!email || !username || !password) {
            this.showAuthMessage('register', this.i18n.t('errors.allFieldsRequired'));
            return;
        }

        if (password !== confirm) {
            this.showAuthMessage('register', this.i18n.t('errors.passwordMismatch'));
            return;
        }

        const result = await this.authManager.register(username, email, password);
        if (result.success) {
            this.showMainMenu();
        } else {
            this.showAuthMessage('register', result.message);
        }
    }

    async handleConvertGuest() {
        const email = document.getElementById('convert-email-input').value;
        const username = document.getElementById('convert-username-input').value;
        const password = document.getElementById('convert-password-input').value;
        const confirm = document.getElementById('convert-confirm-input').value;

        if (!email || !username || !password) {
            this.showAuthMessage('convert', this.i18n.t('errors.allFieldsRequired'));
            return;
        }

        if (password !== confirm) {
            this.showAuthMessage('convert', this.i18n.t('errors.passwordMismatch'));
            return;
        }

        const result = await this.authManager.convertGuest(username, email, password);
        if (result.success) {
            this.showMainMenu();
            this.showNotification(`${this.i18n.t('notifications.accountSaved')} ${Icons.rocket(20, 'var(--primary-color)')}`);
        } else {
            this.showAuthMessage('convert', result.message);
        }
    }

    showAuthMessage(type, msg) {
        const el = document.getElementById(`${type}-message`);
        if (el) {
            el.textContent = msg;
            setTimeout(() => el.textContent = '', 4000);
        }
    }

    showLoginMessage(msg) {
        this.ui.loginMessage.textContent = msg;
        setTimeout(() => this.ui.loginMessage.textContent = '', 3000);
    }

    hideAllScreens() {
        if (window.PixelBlobBridge) {
            window.PixelBlobBridge.unmountPixelBlob();
        }
        // Ensure we grab screens dynamically to avoid stale references
        const playModeScreen = document.getElementById('play-mode-screen');
        const challengeScreen = document.getElementById('challenge-screen');

        const screens = [
            this.ui.menu,
            this.ui.hud,
            this.ui.gameover,
            this.ui.loginScreen,
            this.ui.forgotPasswordScreen,
            this.ui.resetPasswordScreen,
            this.ui.registerScreen,
            this.ui.convertScreen,
            this.ui.allGames,
            this.ui.skinsScreen,
            this.ui.profileScreen,
            this.ui.challengeScreen || challengeScreen,
            playModeScreen,
            document.getElementById('pixelblob-create-screen'),
            document.getElementById('pixelblob-screen'),
            this.ui.transition,
            this.ui.reviveOverlay,
            document.getElementById('admin-screen')
        ];

        screens.forEach(s => {
            if (s) {
                s.classList.add('hidden');
                s.classList.remove('active');
            }
        });

        if (this.ui.friendsScreen) {
            this.ui.friendsScreen.classList.add('hidden');
            this.ui.friendsScreen.classList.remove('active');
        }
    }

    showLoginScreen() {
        this.hideAllScreens();
        this.ui.loginScreen.classList.remove('hidden');
        this.ui.loginScreen.classList.add('active');
        this.refreshLocalizedTexts();
    }

    showForgotPasswordScreen() {
        this.hideAllScreens();
        if (this.ui.loginEmailInput && this.ui.forgotEmailInput) {
            this.ui.forgotEmailInput.value = this.ui.loginEmailInput.value;
        }
        this.ui.forgotPasswordScreen.classList.remove('hidden');
        this.ui.forgotPasswordScreen.classList.add('active');
        this.refreshLocalizedTexts();
    }

    showResetPasswordScreen() {
        this.hideAllScreens();
        this.ui.resetPasswordScreen.classList.remove('hidden');
        this.ui.resetPasswordScreen.classList.add('active');
        this.refreshLocalizedTexts();
    }

    showRegisterScreen() {
        this.hideAllScreens();
        this.ui.registerScreen.classList.remove('hidden');
        this.ui.registerScreen.classList.add('active');
    }

    showConvertScreen() {
        this.hideAllScreens();
        this.ui.convertScreen.classList.remove('hidden');
        this.ui.convertScreen.classList.add('active');
    }

    showProfile() {
        this.hideAllScreens();
        this.ui.profileScreen.classList.remove('hidden');
        this.ui.profileScreen.classList.add('active');
        this.updateProfileUI();
    }

    async updateProfileUI() {
        if (!this.authManager || !this.authManager.currentUser) return;

        const user = this.authManager.currentUser;

        if (this.ui.profileLevel) this.ui.profileLevel.textContent = user.level || 1;
        if (this.ui.profileTotalCoins) this.ui.profileTotalCoins.textContent = user.coins || 0;

        const xp = user.xp || 0;
        const xpNeeded = this.authManager.getXpForNextLevel(user.level || 1);
        if (this.ui.profileXpText) this.ui.profileXpText.textContent = `${xp} / ${xpNeeded}`;
        if (this.ui.profileXpFill) {
            const pct = Math.min(100, Math.max(0, (xp / xpNeeded) * 100));
            this.ui.profileXpFill.style.width = `${pct}%`;
        }

        // Email Verification Status
        const emailStatus = document.getElementById('profile-email-status');
        if (emailStatus) {
            if (user.isGuest) {
                emailStatus.innerHTML = '<span style="color: var(--secondary-color);">GUEST ACCOUNT</span>';
            } else if (user.isEmailVerified) {
                emailStatus.innerHTML = '<span style="color: lime;">✔ EMAIL VERIFIED</span>';
            } else {
                emailStatus.innerHTML = `
                    <span style="color: #ff3333;">✖ EMAIL NOT VERIFIED</span><br>
                    <button id="profile-resend-btn" style="background:none; border:none; color:var(--primary-color); text-decoration:underline; cursor:pointer; font-size: 0.7rem;">RESEND CODE</button>
                `;
                const resendBtn = document.getElementById('profile-resend-btn');
                if (resendBtn) {
                    resendBtn.onclick = async () => {
                        resendBtn.disabled = true;
                        resendBtn.textContent = "SENDING...";
                        try {
                            const res = await this.authManager.db.resendVerification();
                            this.showNotification(res.message);
                            resendBtn.textContent = "SENT!";
                        } catch (e) {
                            this.showNotification(e.message);
                            resendBtn.textContent = "ERROR";
                            resendBtn.disabled = false;
                        }
                    };
                }
            }
        }

        const emailDisplay = document.getElementById('profile-email-display');
        if (emailDisplay) {
            emailDisplay.textContent = user.isGuest ? "GUEST ACCESS" : (user.email || "No email set");
        }

        // --- Promotion Link Logic ---
        const promoInput = document.getElementById('promotion-link-input');
        const promoBtn = document.getElementById('save-promo-link-btn');
        const promoMsg = document.getElementById('promo-link-msg');

        if (promoInput) {
            promoInput.value = user.promotionLink || '';
        }

        if (promoBtn) {
            promoBtn.onclick = async () => {
                const link = promoInput.value.trim();
                promoBtn.disabled = true;
                promoMsg.textContent = 'Saving...';
                promoMsg.style.color = 'var(--primary-color)';

                const result = await this.authManager.savePromotionLink(link);
                if (result.success) {
                    promoMsg.textContent = link ? 'LINK SAVED!' : 'LINK REMOVED';
                    promoMsg.style.color = 'lime';
                } else {
                    promoMsg.textContent = result.message.toUpperCase();
                    promoMsg.style.color = 'var(--secondary-color)';
                }
                promoBtn.disabled = false;
            };
        }
    }

    // --- Legacy Versus entrypoint disabled ---
    startVersusGame() {
        this.showNotification('Versus mode is no longer available in PixelBlob.');
        this.showMainMenu();
    }



    showFriendsMenu() {
        if (!this.authManager.currentUser) {
            this.showNotification(this.i18n.t('errors.loginFirst'));
            return;
        }

        this.hideAllScreens();
        this.ui.friendsScreen.classList.remove('hidden');
        this.ui.friendsScreen.classList.add('active');

        // Show My Code
        const code = this.authManager.getFriendCode();
        if (this.ui.myFriendCode) this.ui.myFriendCode.textContent = code || "ERROR";

        this.renderFriendsList();
    }

    async handleAddFriend() {
        const code = this.ui.addFriendInput.value.trim().toUpperCase();
        if (!code || code.length !== 6) {
            this.ui.addFriendMsg.textContent = this.i18n.t('friends.invalidCode');
            return;
        }

        const result = await Promise.resolve(this.authManager.addFriend(code)); // Ensure async handling
        if (result.success) {
            this.ui.addFriendMsg.textContent = this.i18n.t('friends.added');
            this.ui.addFriendMsg.style.color = "lime";
            this.ui.addFriendInput.value = "";
            this.renderFriendsList();
        } else {
            this.ui.addFriendMsg.textContent = result.message.toUpperCase();
            this.ui.addFriendMsg.style.color = "var(--secondary-color)";
        }

        setTimeout(() => {
            if (this.ui.addFriendMsg) this.ui.addFriendMsg.textContent = "";
        }, 3000);
    }

    renderFriendsList() {
        const list = this.ui.friendsList;
        list.innerHTML = `<div style="color:#666; text-align:center;">${this.i18n.t('common.loading')}</div>`;

        Promise.resolve(this.authManager.getFriends()).then(friends => {
            list.innerHTML = '';
            if (!friends || friends.length === 0) {
                list.innerHTML = `<div style="color:#666; font-style:italic; text-align: center; padding: 20px;">${this.i18n.t('friends.noFriendsAdded')}<br>${this.i18n.t('friends.shareCode')}</div>`;
                return;
            }

            friends.forEach(friend => {
                const card = document.createElement('div');
                card.className = 'friend-card';

                // Calculate total levels or best score?
                // Let's show Level and specific bests if available
                // Just basic info for now

                card.innerHTML = `
                <div>
                    <div class="friend-name">${friend.username} <span style="font-size:0.8rem; color:var(--primary-color);">${this.i18n.t('profile.levelShort')} ${friend.level}</span></div>
                    <div class="friend-details">${this.i18n.t('profile.totalCoins') } ${friend.coins}</div>
                </div>
                <div style="text-align: right;">
                    <button class="neon-btn small" style="padding: 2px 8px; font-size: 0.7rem;">${this.i18n.t('friends.view')}</button>
                </div>
            `;

                // "View" button shows detailed profile
                const viewBtn = card.querySelector('button');
                viewBtn.addEventListener('click', () => {
                    // Reuse Profile UI but populated with Friend Data
                    // Hide Friends Screen, Show Profile Screen (temporary mode)
                    // We'll hack this by populating the profile UI manually and changing the BACK button behavior

                    this.ui.friendsScreen.classList.add('hidden');
                    this.ui.friendsScreen.classList.remove('active');

                    this.ui.profileScreen.classList.remove('hidden');
                    this.ui.profileScreen.classList.add('active');

                    // Populate with Friend Data
                    this.ui.profileLevel.textContent = friend.level || 1;
                    this.ui.profileXpText.textContent = this.i18n.t('friends.friendStats'); // Hide exact XP progress
                    this.ui.profileXpFill.style.width = '100%';
                    this.ui.profileTotalCoins.textContent = friend.coins || 0;

                    // Update Title
                    const profileTitle = document.getElementById('profile-screen-title');
                    if (profileTitle) profileTitle.textContent = friend.username.toUpperCase();

                    // Temporary Back Button Override
                    const originalBack = this.ui.profileScreen.querySelector('#profile-back-btn');
                    const newBack = originalBack.cloneNode(true);
                    originalBack.parentNode.replaceChild(newBack, originalBack);

                    newBack.addEventListener('click', () => {
                        this.ui.profileScreen.classList.add('hidden');
                        this.ui.profileScreen.classList.remove('active');
                        this.ui.friendsScreen.classList.remove('hidden');
                        this.ui.friendsScreen.classList.add('active');

                        // Restore original Back button behavior (Simulated by reloading or re-binding in showProfile)
                        // Better approach: Re-bind main menu callback when opening Main Profile.
                        // For now, this closure works for "Back to Friends"
                    });
                });

                list.appendChild(card);
            });
        });
    }



    showMainMenu() {
        if (window.PixelBlobBridge) {
            window.PixelBlobBridge.unmountPixelBlob();
        }
        this.hideAllScreens();
        this.ui.menu.classList.remove('hidden');
        this.ui.menu.classList.add('active');
        this.ui.userDisplay.textContent = this.authManager.currentUser ? this.authManager.currentUser.username : 'GUEST';
        this.refreshLocalizedTexts();

        // Ensure HUD elements in menu are visible
        if (this.ui.menuCoinsDisplay) this.ui.menuCoinsDisplay.classList.remove('hidden');
        if (this.ui.userDisplay) this.ui.userDisplay.classList.remove('hidden');

        // Show/hide admin button
        const adminBtn = document.getElementById('admin-btn');
        if (adminBtn) {
            const isAdmin = this.authManager.currentUser && this.authManager.currentUser.isAdmin;
            adminBtn.classList.toggle('hidden', !isAdmin);
        }

        this.updateHUD();

        // Check for gift notifications (once per session)
        if (!this._notificationsChecked) {
            this._notificationsChecked = true;
            this.checkGiftNotifications();
        }
    }

    showPlayModeScreen() {
        this.hideAllScreens();
        const playModeScreen = document.getElementById('play-mode-screen');
        if (playModeScreen) {
            playModeScreen.classList.remove('hidden');
            playModeScreen.classList.add('active');
        }
    }

    showPixelBlobCreateScreen() {
        this.hideAllScreens();
        const createScreen = document.getElementById('pixelblob-create-screen');
        if (createScreen) {
            createScreen.classList.remove('hidden');
            createScreen.classList.add('active');
        }
    }

    async showPixelBlobScreen(options = {}) {
        this.hideAllScreens();
        const pixelBlobScreen = document.getElementById('pixelblob-screen');
        if (pixelBlobScreen) {
            pixelBlobScreen.classList.remove('hidden');
            pixelBlobScreen.classList.add('active');
        }
        const mountPoint = document.getElementById('pixelblob-mount');
        if (window.PixelBlobBridge && mountPoint) {
            await window.PixelBlobBridge.mountPixelBlob(mountPoint, options);
        }
    }

    hidePixelBlobScreen() {
        if (window.PixelBlobBridge) {
            window.PixelBlobBridge.unmountPixelBlob();
        }
        const pixelBlobScreen = document.getElementById('pixelblob-screen');
        if (pixelBlobScreen) {
            pixelBlobScreen.classList.add('hidden');
            pixelBlobScreen.classList.remove('active');
        }
        this.showMainMenu();
    }

    async checkGiftNotifications() {
        if (!this.authManager.currentUser || !this.authManager.db.token) {
            console.log('[Notifications] Skipped: no user or token');
            return;
        }

        // Small delay to ensure session is fully established
        await new Promise(r => setTimeout(r, 1000));

        try {
            console.log('[Notifications] Checking for gift notifications...');
            const res = await fetch(`${this.authManager.db.baseUrl}/user/notifications?_t=${Date.now()}`, {
                headers: {
                    'Authorization': `Bearer ${this.authManager.db.token}`,
                    'Content-Type': 'application/json'
                },
                cache: 'no-store'
            });

            if (!res.ok) {
                console.warn('[Notifications] API returned', res.status);
                return;
            }

            const notifications = await res.json();
            console.log('[Notifications] Received:', notifications);

            if (!Array.isArray(notifications) || notifications.length === 0) return;

            // Show notifications one by one
            for (let i = 0; i < notifications.length; i++) {
                const notif = notifications[i];
                if (notif.type === 'gift' || notif.type === 'premium') {
                    await this.showGiftNotification(notif);
                }
            }

            // Mark all as read
            await fetch(`${this.authManager.db.baseUrl}/user/notifications/read`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.authManager.db.token}`,
                    'Content-Type': 'application/json'
                }
            });

            // Refresh user data to get updated coin balance
            const user = await this.authManager.db.getUser();
            if (user) {
                this.authManager.currentUser.coins = user.coins;
                this.updateHUD();
            }
        } catch (err) {
            console.error('[Notifications] Check failed:', err);
        }
    }

    showGiftNotification(notif, delay = 0) {
        return new Promise(resolve => {
            setTimeout(() => {
                const overlay = document.createElement('div');
                overlay.className = 'gift-notif-overlay';
                overlay.innerHTML = `
                    <div class="gift-notif-card">
                        <div class="neon-gift-icon-container">
                            <div class="neon-gift-box"></div>
                            <div class="neon-gift-lid"></div>
                            <div class="neon-gift-ribbon-v"></div>
                            <div class="neon-gift-ribbon-h"></div>
                            <div class="neon-gift-bow-left"></div>
                            <div class="neon-gift-bow-right"></div>
                        </div>
                        <div class="gift-notif-title">${notif.type === 'premium' ? 'PREMIUM UNLOCKED!' : 'GIFT RECEIVED!'}</div>
                        ${notif.coins > 0 ? `
                        <div class="gift-notif-coins">
                            <span class="coin-icon"></span>+${notif.coins}
                        </div>` : ''}
                        <div class="gift-notif-message">${notif.message}</div>
                        <button class="gift-notif-ok">AWESOME!</button>
                    </div>
                `;
                document.body.appendChild(overlay);

                overlay.querySelector('.gift-notif-ok').addEventListener('click', () => {
                    overlay.style.opacity = '0';
                    overlay.style.transition = 'opacity 0.3s ease';
                    setTimeout(() => {
                        overlay.remove();
                        resolve();
                    }, 300);
                });

                // Also dismiss on overlay click (outside card)
                overlay.addEventListener('click', (e) => {
                    if (e.target === overlay) {
                        overlay.style.opacity = '0';
                        overlay.style.transition = 'opacity 0.3s ease';
                        setTimeout(() => {
                            overlay.remove();
                            resolve();
                        }, 300);
                    }
                });
            }, delay);
        });
    }

    showSkinsMenu() {
        this.inShop = true;

        this.ui.menu.classList.add('hidden');
        this.ui.menu.classList.remove('active');
        this.ui.skinsScreen.classList.remove('hidden');
        this.ui.skinsScreen.classList.add('active');

        this.ui.skinsGrid.innerHTML = '';
        this.ui.skinsGridEffects.innerHTML = '';
        this.ui.skinsGridCoins.innerHTML = '';
        this.renderBlobShopCategory('food', this.ui.skinsGrid);
        this.renderBlobShopCategory('control', this.ui.skinsGridEffects);
        this.renderBlobShopCategory('nest', this.ui.skinsGridCoins);

        // Restore active tab
        this.switchSkinsTab(this.currentSkinsTab);
    }

    getBlobInventory() {
        try {
            const raw = localStorage.getItem(BLOB_INVENTORY_KEY);
            return raw ? JSON.parse(raw) : {};
        } catch {
            return {};
        }
    }

    saveBlobInventory(inventory) {
        localStorage.setItem(BLOB_INVENTORY_KEY, JSON.stringify(inventory));
    }

    renderBlobShopCategory(category, container) {
        const items = BLOB_SHOP_ITEMS.filter(item => item.category === category);
        const inventory = this.getBlobInventory();
        const coins = Number(this.authManager.currentUser?.coins || 0);

        items.forEach(item => {
            const card = document.createElement('div');
            card.className = `skin-card rarity-${item.rarity}`;
            card.innerHTML = `
                <div class="skin-name">${item.name}</div>
                <div style="font-size:0.75rem;opacity:0.8;min-height:34px;">${item.description}</div>
                <div class="skin-price"><span class="coin-icon" style="display:inline-block;vertical-align:middle;transform:scale(0.8);"></span> ${item.coinCost}</div>
                <div style="font-size:0.75rem;opacity:0.9;">Stock: ${inventory[item.id] || 0}</div>
            `;
            card.addEventListener('click', async () => {
                if (coins < item.coinCost) {
                    this.showNotification('Pas assez de coins');
                    return;
                }
                if (await this.showConfirm(`Acheter ${item.qty}x ${item.name} pour ${item.coinCost} coins ?`)) {
                    const ok = await this.authManager.spendCoins(item.coinCost);
                    if (!ok) {
                        this.showNotification('Achat impossible');
                        return;
                    }
                    const next = this.getBlobInventory();
                    next[item.id] = (next[item.id] || 0) + item.qty;
                    this.saveBlobInventory(next);
                    this.showNotification(`${item.qty}x ${item.name} ajouté à l'inventaire blob`);
                    this.updateHUD();
                    this.showSkinsMenu();
                }
            });
            container.appendChild(card);
        });
    }

    switchSkinsTab(tab) {
        this.currentSkinsTab = tab;

        // Reset ALL first
        this.ui.skinsGrid.classList.add('hidden');
        this.ui.skinsGridEffects.classList.add('hidden');
        this.ui.skinsGridCoins.classList.add('hidden');

        this.ui.tabColors.classList.remove('active');
        this.ui.tabEffects.classList.remove('active');
        this.ui.tabCoins.classList.remove('active');

        this.ui.tabColors.style.opacity = '0.5';
        this.ui.tabEffects.style.opacity = '0.5';
        this.ui.tabCoins.style.opacity = '0.5';

        if (tab === 'colors') {
            this.ui.skinsGrid.classList.remove('hidden');
            this.ui.tabColors.classList.add('active');
            this.ui.tabColors.style.opacity = '1';
        } else if (tab === 'effects') {
            this.ui.skinsGridEffects.classList.remove('hidden');
            this.ui.tabEffects.classList.add('active');
            this.ui.tabEffects.style.opacity = '1';
        } else if (tab === 'coins') {
            this.ui.skinsGridCoins.classList.remove('hidden');
            this.ui.tabCoins.classList.add('active');
            this.ui.tabCoins.style.opacity = '1';
        }
    }

    refillGameDeck() {
        // Clone the full list
        this.gameDeck = [...this.gamesList];

        // Fisher-Yates Shuffle
        for (let i = this.gameDeck.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [this.gameDeck[i], this.gameDeck[j]] = [this.gameDeck[j], this.gameDeck[i]];
        }

        // Avoid immediate repetition if possible (check last game played vs first in new deck)
        if (this.nextGameClass && this.gameDeck.length > 1 && this.gameDeck[this.gameDeck.length - 1].class === this.nextGameClass) {
            // Swap the last one (which will be popped first) with the one before it
            const last = this.gameDeck.length - 1;
            [this.gameDeck[last], this.gameDeck[last - 1]] = [this.gameDeck[last - 1], this.gameDeck[last]];
        }
    }


    hideSkinsMenu() {
        this.inShop = false;

        this.ui.skinsScreen.classList.add('hidden');
        this.ui.skinsScreen.classList.remove('active');
        this.ui.menu.classList.remove('hidden');
        this.ui.menu.classList.add('active');
    }

    // Old leaderboard methods removed


    showAllGames() {
        this.state = 'MENU';
        this.refreshLocalizedTexts();

        // Clear any pending transitions
        if (this.transitionTimeout) {
            clearTimeout(this.transitionTimeout);
            this.transitionTimeout = null;
        }

        // Force hide all other screens
        this.ui.menu.classList.add('hidden');
        this.ui.menu.classList.remove('active');
        this.ui.hud.classList.add('hidden');
        this.ui.gameover.classList.add('hidden');
        this.ui.gameover.classList.remove('active');
        this.ui.transition.classList.add('hidden');
        this.ui.transition.classList.remove('active');
        this.quitBtn.classList.add('hidden');

        // Show All Games screen
        this.ui.allGames.classList.remove('hidden');
        this.ui.allGames.classList.add('active');

        // Populate Grid
        this.ui.gamesGrid.innerHTML = '';

        // --- PROGRESSION: Show ALL Games with Locked States ---
        const unlockedCount = this.gamesList.filter(g => this.authManager.isGameUnlocked(g.class.name) || g.name === 'Tap').length;

        // Update Counter
        const countDisplay = document.getElementById('unlocked-count-display');
        if (countDisplay) {
            countDisplay.textContent = `${unlockedCount}/${this.gamesList.length}`;
        }

        this.gamesList.forEach((game, index) => {
            const isUnlocked = this.authManager.isGameUnlocked(game.class.name) || game.name === 'Tap';
            const card = document.createElement('div');
            card.className = isUnlocked ? 'game-card' : 'game-card locked';
            card.style.position = 'relative';

            const indexBadge = document.createElement('div');
            indexBadge.style.position = 'absolute';
            indexBadge.style.top = '4px';
            indexBadge.style.left = '4px';
            indexBadge.style.fontSize = '0.7rem';
            indexBadge.style.opacity = '0.5';
            indexBadge.textContent = `#${index + 1}`;
            card.appendChild(indexBadge);

            if (isUnlocked) {
                const title = document.createElement('div');
                title.className = 'game-card-title';
                title.textContent = this.getLocalizedGameName(game);

                // Tutorial Badge
                const tutorialBadge = document.createElement('div');
                tutorialBadge.className = 'tutorial-badge';
                tutorialBadge.textContent = this.i18n.t('tutorial.badge') || '?';
                tutorialBadge.addEventListener('click', (e) => {
                    e.stopPropagation(); // Do not start the game
                    this.tutorialManager.showWithPlayback(game.class, null, null, { isPreview: true });
                });
                card.appendChild(tutorialBadge);

                // High Score Badge
                const scores = this.leaderboardManager.getHighScores(game.name);
                if (scores.length > 0) {
                    const top = scores[0];
                    const badge = document.createElement('div');
                    badge.className = 'highscore-badge';
                    badge.textContent = `${this.i18n.t('allGames.champ')}: ${top.name} (${top.score})`;
                    badge.style.fontSize = '0.7rem';
                    badge.style.color = 'var(--accent-color)';
                    badge.style.marginTop = '5px';
                    card.appendChild(badge);
                }

                card.appendChild(title);
                card.addEventListener('click', () => this.startInfiniteMode(game));
            } else {
                const icon = document.createElement('div');
                icon.className = 'game-card-icon';
                icon.style.opacity = '0.3';
                icon.innerHTML = Icons.lock(32, 'var(--primary-color)');
                card.appendChild(icon);

                const title = document.createElement('div');
                title.className = 'game-card-title';
                title.textContent = '???';
                card.appendChild(title);
            }

            this.ui.gamesGrid.appendChild(card);
        });
    }

    getLocalizedGameName(game) {
        if (!game || !game.class || !game.class.name) return game?.name || '';
        return this.i18n.t(`games.${game.class.name}`, { defaultName: game.name || game.class.name });
    }

    filterAllGames(query) {
        const term = query.toLowerCase();
        const cards = this.ui.gamesGrid.querySelectorAll('.game-card');

        cards.forEach(card => {
            const title = card.querySelector('.game-card-title').textContent.toLowerCase();
            if (title.includes(term)) {
                card.style.display = 'flex';
            } else {
                card.style.display = 'none';
            }
        });
    }

    hideAllGames() {
        this.ui.allGames.classList.add('hidden');
        this.ui.allGames.classList.remove('active');
        // Return to Play Mode Screen
        document.getElementById('play-mode-screen').classList.remove('hidden');
    }

    async startInfiniteMode(gameData) {
        // ENERGY CHECK
        if (this.authManager && this.authManager.currentUser) {
            const energyResult = await this.authManager.startGame(); // Deduct 1 Energy
            if (!energyResult.success) {
                const energyIcon = Icons.energy(20, 'var(--secondary-color)');
                if (await this.showConfirm(`NO ENERGY LEFT! ${energyIcon}\n\nVisit Shop for Energy?`)) {
                    this.showSkinsMenu();
                }
                return;
            }
            this.updateHUD(); // Refresh UI to show new energy
        }

        this.hideAllScreens(); // Ensure Play Mode / All Games are hidden
        this.gameMode = 'INFINITE';
        this.score = 0;
        this.elapsedTime = 0;
        this.scoreAccumulator = 0;
        this.startTime = Date.now(); // Start Timer
        this.speedMultiplier = this.STARTING_SPEED_MULTIPLIER; // DEFAULT IS 1.0, SET IN CONSTRUCTOR
        this.reviveCount = 0;
        this.roundsWon = 0; // FIX: Ensure roundsWon is initialized
        
        // Clear any pending transition from a previous game
        if (this.transitionTimeout) {
            clearTimeout(this.transitionTimeout);
            this.transitionTimeout = null;
        }
        this.isChallengeMode = false;
        this.activeChallenge = null;

        this.refillGameDeck(); // Init Deck

        this.ui.hud.classList.remove('hidden');
        this.quitBtn.classList.remove('hidden');

        // Check if Global (Array) or Single (Object)
        if (Array.isArray(gameData) || !gameData) {
            // GLOBAL INFINITE MODE
            this.lives = 3;
            this.isGlobalInfinite = true;
            this.infiniteGameName = 'Global';
            this.nextGameClass = null;
            console.log("Starting GLOBAL Infinite Mode (3 Lives)");
        } else {
            // SINGLE GAME INFINITE (Sudden Death)
            this.lives = 1;
            this.isGlobalInfinite = false;
            this.nextGameClass = gameData.class;
            this.infiniteGameName = gameData.name;
            console.log(`Starting SINGLE Infinite Mode: ${gameData.name}`);
        }

        // Initialize HUD with correct score/lives
        this.updateHUD();

        this.state = 'TRANSITION';
        this.ui.transition.classList.remove('hidden');
        this.ui.transition.classList.add('active');

        const actionText = this.isGlobalInfinite ? "SURVIVE!" : (gameData.action || "READY?");
            this.ui.instruction.innerHTML = `${this.i18n.t('modes.infiniteLabel')}<br><span style="font-size: 0.8em; color: var(--primary-color)">${actionText}</span>`;

        this.transitionTimeout = setTimeout(() => {
            this.ui.transition.classList.add('hidden');
            this.ui.transition.classList.remove('active');
            if (this.isGlobalInfinite) {
                this.nextRound(); // Pick random game
            } else {
                this.startMicrogame(); // Start specific game
            }
        }, 1500);
    }

    async quitGame() {
        console.log("[GameEngine] Quitting Game... Force Stop.");
        this.state = 'MENU';
        this.gameRunning = false; // Stop loop logic
        this.score = 0;
        this.lives = 4;
        this.speedMultiplier = 1.0;
        this.gameMode = 'STANDARD';
        if (this.ui.score) this.ui.score.style.display = ''; // Restore score

        // Critical: Clear Challenge Flags
        this.isChallengeMode = false;
        this.activeChallenge = null; // Prevent loop safety net from reviving it

        this.ui.reviveOverlay.classList.add('hidden');
        this.ui.reviveOverlay.classList.remove('active');

        // Clear any pending transition
        if (this.transitionTimeout) {
            clearTimeout(this.transitionTimeout);
            this.transitionTimeout = null;
        }

        // Hide game UI
        this.ui.hud.classList.add('hidden');
        this.ui.gameover.classList.add('hidden');
        this.ui.gameover.classList.remove('active');
        this.ui.transition.classList.add('hidden');
        this.ui.transition.classList.remove('active');

        if (this.quitBtn) this.quitBtn.classList.add('hidden');

        // Hide All Games screen if open
        if (this.ui.allGames) {
            this.ui.allGames.classList.add('hidden');
            this.ui.allGames.classList.remove('active');
        }

        // Hide Challenge Screen if open
        if (this.ui.challengeScreen) {
            this.ui.challengeScreen.classList.add('hidden');
            this.ui.challengeScreen.classList.remove('active');
        }

        // Show Main Menu
        if (this.ui.menu) {
            this.ui.menu.classList.remove('hidden');
            this.ui.menu.classList.add('active');
        }

        // Cleanup current microgame if running
        if (this.currentMicrogame) {
            if (typeof this.currentMicrogame.cleanup === 'function') {
                this.currentMicrogame.cleanup();
            }
            this.currentMicrogame = null;
        }
        this.nextGameClass = null;

        console.log("[GameEngine] Quit Complete. State: MENU.");
    }

    init() {
        console.log('Game Engine Initialized');
        this.loop = this.loop.bind(this);
        this.refreshLocalizedTexts();
        requestAnimationFrame(this.loop);
    }

    refreshLocalizedTexts() {
        this.i18n.applyDomTranslations();
    }

    async reloadProfileScreenAfterLanguageChange() {
        if (!this.ui.profileScreen || this.ui.profileScreen.classList.contains('hidden')) return;
        try {
            await this.showProfile();
        } catch (err) {
            console.warn('[GameEngine] Failed to reload profile after language change:', err);
        }
    }

    async startGame(modeOverride = 'STANDARD') {
        // ENERGY CHECK (Server Safe)
        if (this.authManager && this.authManager.currentUser) {
            console.log("[GameEngine] Checking Energy...");
            const energyResult = await this.authManager.startGame();
            if (!energyResult.success) {
                console.warn("[GameEngine] START ABORTED: No Energy", energyResult);
                const energyIcon = Icons.energy(16, 'var(--secondary-color)');
                this.showNotification(`${energyIcon} NO ENERGY! REFILL IN SHOP ${energyIcon}`, 4000);
                // Ideally show Shop/Premium Modal here
                const energyIconLarge = Icons.energy(20, 'var(--secondary-color)');
                if (await this.showConfirm(`NO ENERGY LEFT! ${energyIconLarge}\n\nBuy Premium for INFINITE Energy? (10€)`)) {
                    this.authManager.buyPremium();
                }
                return;
            }
        }

        this.gameMode = modeOverride;
        this.isChallengeMode = false;
        this.activeChallenge = null;
        this.score = 0;

        // Lives setting
        this.lives = 4;

        this.reviveCount = 0;
        this.speedMultiplier = 1.0;

        // Time/Score Init
        this.startTime = Date.now();
        this.scoreAccumulator = 0;
        this.roundsWon = 0;

        this.ui.menu.classList.add('hidden');
        this.ui.menu.classList.remove('active');
        this.ui.gameover.classList.add('hidden');
        this.ui.gameover.style.display = '';

        this.ui.hud.classList.remove('hidden');
        this.quitBtn.classList.remove('hidden');
        this.ui.transition.classList.remove('neon-pulse-bg');
        this.ui.transition.style.background = '';

        // Initialize HUD with correct score/lives AFTER showing it
        this.updateHUD();

        this.nextRound();
    }

    resetGame() {
        this.ui.gameover.classList.add('hidden');
        this.ui.gameover.classList.remove('active');

        if (this.gameMode === 'INFINITE') {
            if (this.isGlobalInfinite) {
                // Restart Global Infinite
                this.startInfiniteMode(this.gamesList);
            } else {
                // Restart Single Game Infinite (All Games Mode)
                const gameData = this.gamesList.find(g => g.class === this.nextGameClass);
                if (gameData) {
                    console.log(`[GameEngine] Retrying Single Game: ${gameData.name}`);
                    this.startInfiniteMode(gameData);
                } else {
                    console.error("[GameEngine] Could not find game data for retry. Fallback to global.");
                    this.startInfiniteMode(this.gamesList);
                }
            }
        } else if (this.gameMode === 'CHALLENGE' && this.activeChallenge) {
            // Just in case we somehow get here in challenge mode
            this.startChallenge(this.activeChallenge);
        } else {
            // Standard Mode
            this.startGame();
        }
    }

    showNotification(message, duration = 3000) {
        let container = document.getElementById('notification-container');
        if (!container) {
            container = document.createElement('div');
            container.id = 'notification-container';
            container.className = 'neon-notification-container';
            document.body.appendChild(container);
        }

        const notif = document.createElement('div');
        notif.className = 'neon-notification';
        const translated = this.i18n.translateNotificationMessage(message);
        notif.innerHTML = translated;

        container.appendChild(notif);

        // Auto remove
        setTimeout(() => {
            notif.classList.add('hiding');
            notif.addEventListener('animationend', () => notif.remove());
        }, duration);
    }

    showConfirm(message) {
        return new Promise((resolve) => {
            if (this.ui.confirmMessage) this.ui.confirmMessage.innerHTML = message.replace(/\n/g, '<br>');
            if (this.ui.confirmOverlay) {
                this.ui.confirmOverlay.classList.remove('hidden');
                this.ui.confirmOverlay.style.display = 'flex';
            }

            const cleanup = () => {
                if (this.ui.confirmOverlay) {
                    this.ui.confirmOverlay.classList.add('hidden');
                    this.ui.confirmOverlay.style.display = 'none';
                }
                if (this.ui.confirmYes) this.ui.confirmYes.onclick = null;
                if (this.ui.confirmNo) this.ui.confirmNo.onclick = null;
            };

            if (this.ui.confirmYes) {
                this.ui.confirmYes.onclick = () => {
                    cleanup();
                    resolve(true);
                };
            }

            if (this.ui.confirmNo) {
                this.ui.confirmNo.onclick = () => {
                    cleanup();
                    resolve(false);
                };
            }
        });
    }

    showScreen(screen) {
        // Handle input being a string or an object
        let screenEl = screen;
        if (typeof screen === 'string') {
            screenEl = document.getElementById(screen);
            if (!screenEl) {
                console.error(`[GameEngine] showScreen: Element with ID '${screen}' not found.`);
                return;
            }
        }

        // SAFETY INTERCEPT: If attempting to show Game Over while in Challenge Mode, redirect.
        if (screenEl && screenEl.id === 'game-over') {
            if (this.isChallengeMode || this.activeChallenge) {
                console.warn("[GameEngine] Intercepted Game Over Screen in Challenge Mode. Redirecting...");
                this.finishChallenge(false);
                return;
            }
        }

        // Hide all screens first
        const screens = document.querySelectorAll('.screen');
        screens.forEach(s => {
            s.classList.add('hidden');
            s.classList.remove('active');
        });

        // Show target
        if (screenEl) {
            screenEl.classList.remove('hidden');
            screenEl.classList.add('active');
            screenEl.style.display = ''; // Ensure inline styles don't conflict
        }
    }

    nextRound() {
        if (this.lives <= 0) {
            this.gameOver();
            return;
        }

        this.state = 'TRANSITION';
        this.ui.transition.classList.remove('hidden');
        this.ui.transition.classList.add('active');

        // Visual Cleanup for Standard Mode (Remove Versus styles if any leaked)
        this.ui.transition.classList.remove('neon-pulse-bg');
        this.ui.transition.style.background = 'var(--primary-color)'; // Force Cyan for Standard/Infinite
        this.ui.transition.style.color = '#000'; // Force Black text

        // Select Next Game HERE
        let nextGameName = this.i18n.t('microgames.ready');
        let nextGameAction = '';

        if (this.gameMode === 'STANDARD' || (this.gameMode === 'INFINITE' && this.isGlobalInfinite)) {
            // Deck System for Variety
            if (this.gameDeck.length === 0) {
                this.refillGameDeck();
            }

            // Pop the next game from the shuffled deck
            const selectedGame = this.gameDeck.pop();
            this.nextGameClass = selectedGame.class;
            nextGameName = this.getLocalizedGameName(selectedGame).toUpperCase();
            nextGameAction = selectedGame.action || '';
        } else if (this.nextGameClass) {
            // Infinite mode (Single) or specific class
            const g = this.gamesList.find(x => x.class === this.nextGameClass);
            if (g) {
                nextGameName = this.getLocalizedGameName(g).toUpperCase();
                nextGameAction = g.action || '';
            }
        }

        // Speed Up logic based on rounds
        const speedUp = this.gameMode === 'STANDARD' && this.score > 0 && this.score % 5 === 0;
        if (speedUp && this.gameMode !== 'INFINITE') {
            this.speedMultiplier = Math.min(this.speedMultiplier + 0.1, this.maxSpeed);
        }

        let html = `
            <div style="font-size: 1.5rem; font-weight: bold; margin-bottom: 10px; color: #000;">${this.gameMode === 'INFINITE' ? this.i18n.t('rounds.nextRound') : this.i18n.t('rounds.getReady')}</div>
            <div style="font-size: 2.5rem; font-weight: 900; color: #000; text-transform: uppercase; margin-bottom: 5px;">${nextGameName}</div>
            <div style="font-size: 3.5rem; font-weight: 900; color: var(--primary-color); text-shadow: 2px 2px 0px #000; text-transform: uppercase; margin-bottom: 15px;">${nextGameAction}</div>
            <div style="font-size: 1.1rem; font-weight: bold; color: #000;">${this.i18n.t('rounds.speedLabel')}: x${this.speedMultiplier.toFixed(1)}</div>
        `;

        if (speedUp) {
            html += `
                <div style="margin-top: 20px; font-size: 1.5rem; font-weight: bold; color: #ccff00; text-shadow: 0 0 10px #000;">
                    SPEED UP! <div class="speed-up-arrow"></div>
                </div>
            `;
        }

        this.ui.instruction.innerHTML = html;

        // Support 'infinite_no_timer' with reduced transition
        let delay = 2000 / this.speedMultiplier;
        if (this.activeChallenge && this.activeChallenge.mode === 'infinite_no_timer') {
            delay = 500; // Fast transition
        }

        this.transitionTimeout = setTimeout(() => {
            this.ui.transition.classList.add('hidden');
            this.ui.transition.classList.remove('active');
            this.startMicrogame();
        }, delay);
    }

    startMicrogame() {
        this.state = 'PLAYING';
        this.gameRunning = true; // Ensure loop is active
        this.lastFrameTime = 0; // CRITICAL: Reset frame timer to prevent huge DT jumps on restart

        try {
            const GameClass = this.nextGameClass || TapGame;

            // --- PROGRESSION: Unlock Game on Encounter ---
            // Skip in Versus to avoid API spam/latency/crashes during MP
            if (this.authManager && !this.authManager.isGameUnlocked(GameClass.name)) {
                this.authManager.unlockGame(GameClass.name);
                // Game was just unlocked!
                this.ui.instruction.innerHTML += `<div style="font-size: 1rem; color: #00ff00; margin-top: 10px; animation: blink 1s infinite;">NEW GAME DISCOVERED!</div>`;
            }

            this.currentMicrogame = new GameClass(this);

            // APPLY CHALLENGE CONFIGURATION
            if (this.activeChallenge && this.activeChallenge.config) {
                if (typeof this.currentMicrogame.applyConfig === 'function') {
                    console.log(`[GameEngine] Applying config to ${GameClass.name}:`, this.activeChallenge.config);
                    this.currentMicrogame.applyConfig(this.activeChallenge.config);
                }
            }

            this.currentMicrogame.start();

            // Use Challenge Duration > Microgame Override > Default
            let baseTime = 3000;
            if (this.activeChallenge && this.activeChallenge.duration) {
                baseTime = this.activeChallenge.duration;
            } else if (this.currentMicrogame.duration) {
                baseTime = this.currentMicrogame.duration;
            }
            // FIX: Only allow Infinite Mode for DodgeGame (Regression Fix)
            if (this.gameMode === 'CHALLENGE' && this.activeChallenge && this.activeChallenge.mode === 'infinite_no_timer') {
                this.maxTime = Infinity;
                this.timer = Infinity;
            } else {
                this.maxTime = baseTime / this.speedMultiplier;
                this.timer = this.maxTime;
            }
            console.log(`[GameEngine] Timer Init: Base=${baseTime}, Mult=${this.speedMultiplier}, MaxTime=${this.maxTime}`);

            // Handle Timer UI Visibility
            if (this.currentMicrogame.hideTimer) {
                this.ui.timerFill.parentElement.style.display = 'none';
            } else {
                this.ui.timerFill.parentElement.style.display = 'block';
            }

            console.log('Microgame Started:', GameClass.name);
        } catch (error) {
            console.error("Failed to start microgame:", error);
            this.handleMicrogameResult(false); // Fail gracefully
        }
    }

    gameOver() {
        if (this.state === 'CHALLENGE_COMPLETED') {
            console.log("[GameEngine] Ignoring Game Over - Challenge Completed.");
            return;
        }

        console.log("🔥 GAME OVER TRIGGERED. Final Score:", this.score);
        console.log("Current User:", this.authManager.currentUser);
        this.gameRunning = false;

        // Cleanup any pending transitions
        if (this.transitionTimeout) {
            clearTimeout(this.transitionTimeout);
            this.transitionTimeout = null;
        }

        // --- CHALLENGE / INFINITE CHALLENGE REDIRECT ---
        // Use Robust Flag
        if (this.isChallengeMode || this.gameMode === 'CHALLENGE' || this.activeChallenge) {
            console.log("[GameEngine] Challenge Failed/Ended. Redirecting to Challenge Menu...", this.activeChallenge ? this.activeChallenge.name : 'Unknown');
            this.finishChallenge(false);
            return;
        }

        // --- STANDARD GAME OVER FLOW ---
        // FINAL SAFETY CHECK: Are we SURE we aren't in a challenge?
        if (this.isChallengeMode || this.activeChallenge) {
            console.warn("[GameEngine] Caught late Challenge Mode flag in Game Over. Redirecting.");
            this.finishChallenge(false);
            return;
        }

        this.state = 'GAMEOVER';
        this.ui.hud.classList.add('hidden');
        this.ui.gameover.classList.remove('hidden');
        this.ui.gameover.classList.add('active');
        this.ui.gameover.style.display = ''; // Ensure visibility (undoing nuclear option)

        // Show Final Score (Points - Integer)
        if (this.ui.finalScore) {
            this.ui.finalScore.textContent = Math.floor(this.score);
        }

        // --- PROGRESSION & SOCIAL: Submit Result ---
        const gameKey = this.gameMode === 'STANDARD' ? 'TapGame' : this.infiniteGameName; // 'TapGame' is default for Standard
        // Note: For Standard mode, we might want to track 'StandardPb' or per-game? 
        // Prototype logic: Standard Mode uses 'TapGame' mechanics mostly or is a mix? 
        // Based on code, Standard = WarioWare style mix. Let's use 'Standard' as key.
        const effectiveKey = this.gameMode === 'STANDARD' ? 'Global' : this.infiniteGameName;

        // Duration? We track this.timer but that's countdown. We need elapsed.
        // For Beta, let's just send 30s as placeholder or track start time.
        // Let's rely on Score for now.

        if (this.authManager && this.authManager.currentUser) {
            // DEFERRED SUBMISSION: We wait for Arcade Input (if Highscore) or submit immediately (if low score).
            // Logic moved down to UI block.

            // Global PB
            this.authManager.updatePersonalBest('Global', this.score);

            // --- SHOW RANKINGS ---
            const ranksDiv = document.getElementById('rankings-display');
            if (ranksDiv) {
                let rankKey = 'Global';
                if (this.gameMode === 'INFINITE' && this.infiniteGameName) {
                    rankKey = this.infiniteGameName;
                }

                // Async fetch for ranks (API mode support)
                Promise.resolve(this.authManager.getUserRanks(rankKey)).then(ranks => {
                    if (ranks) {
                        ranksDiv.innerHTML = `
                            <div>GLOBAL RANK: <span style="color:var(--primary-color); font-weight:bold;">#${ranks.globalRank}</span></div>
                            <div>FRIEND RANK: <span style="color:var(--secondary-color); font-weight:bold;">#${ranks.friendRank}</span></div>
                        `;
                        ranksDiv.style.display = 'flex';
                    } else {
                        ranksDiv.style.display = 'none';
                    }
                });
            }

            // Show Share Button
            if (this.ui.shareBtn) {
                this.ui.shareBtn.style.display = 'inline-block';
            }
        } else {
            if (this.ui.shareBtn) this.ui.shareBtn.style.display = 'none';
            const ranksDiv = document.getElementById('rankings-display');
            if (ranksDiv) ranksDiv.style.display = 'none';
        }

        // Check High Score
        // Ensure key is valid
        let key = 'standard';
        if (this.gameMode === 'INFINITE') {
            key = this.infiniteGameName || 'Tap'; // Fallback to Tap if name missing
        } else if (this.gameMode === 'CHALLENGE') {
            key = 'challenge';
        }

        console.log(`[GameEngine] Submitting Result: Mode=${this.gameMode}, Key=${key}, Score=${this.score}`);

        // Clear previous dynamic UI
        const existingInput = document.getElementById('name-input-ui');
        if (existingInput) existingInput.style.display = 'none';
        const existingLb = document.getElementById('leaderboard-ui');
        if (existingLb) existingLb.innerHTML = '';

        // 1. AUTO-SAVE (Coins/XP immediately)
        let submitPromise = Promise.resolve(null);
        if (this.authManager && this.authManager.currentUser) {
            // Check for valid key before submitting
            if (key) {
                // Send actual duration (minimum 2s to bypass simple generic filter)
                const actualDuration = Math.max(2, Math.floor((Date.now() - this.startTime) / 1000));
                // Pass roundsWon as the 4th argument (new)
                submitPromise = this.authManager.submitGameResult(key, this.score, actualDuration, this.roundsWon);
            } else {
                console.error("Invalid Game Key, skipping submission");
            }
        }

        submitPromise.then(res => {
            const currentScoreId = res ? res.scoreId : null;

            // 2. SHOW UI (Leaderboard Preview Only - No Input)
            // User requested to remove 3-letter input and just save automatically (which is done above).
            // We just show the leaderboard now.
            this.leaderboardManager.showLeaderboardPreview(key, this.ui.gameover);

            // Allow profile update to reflect new high score immediately
            this.updateProfileUI();
        });
    }

    update(dt) {
        if (this.state === 'PLAYING') {
            // Time Scoring Update
            // Calculate score as elapsed time (sec.cc)
            // Score System: Points per 100ms scaled by Speed
            // Score System: Points per 100ms scaled by Speed
            // EXCEPTION: In Challenge Mode, we use "Rounds" (1 per round).
            const isChallenge = this.gameMode === 'CHALLENGE' || this.activeChallenge || this.isChallengeMode;

            if (this.startTime > 0 && !isChallenge) {
                // We use dt (delta time in ms) to accumulate
                this.scoreAccumulator += dt;
                const TICK_RATE = 100; // 100ms

                while (this.scoreAccumulator >= TICK_RATE) {
                    this.scoreAccumulator -= TICK_RATE;
                    // Formula: 1 Point * Speed Multiplier (rounded)
                    this.score += Math.round(1 * this.speedMultiplier);
                }

                // Update HUD Score
                if (this.ui.score) {
                    this.ui.score.textContent = Math.floor(this.score);
                }
            }

            // Only update timer if NOT hidden
            if (!this.currentMicrogame || !this.currentMicrogame.hideTimer) {
                if (this.timer !== Infinity) {
                    this.timer -= dt;
                    const pct = Math.max(0, this.timer / this.maxTime);
                    this.ui.timerFill.style.width = `${pct * 100}%`;
                } else {
                    this.ui.timerFill.style.width = '100%';
                }

                if (this.timer <= 0) {
                    // Check if microgame handles timeout as win (e.g. CountGame)
                    if (this.currentMicrogame && typeof this.currentMicrogame.onTimeout === 'function') {
                        if (this.currentMicrogame.onTimeout()) {
                            this.handleMicrogameResult(true);
                            return;
                        }
                    }
                    if (this.activeChallenge && this.activeChallenge.config && this.activeChallenge.config.timeAttack) {
                        // For Time Attack, timeout matches end of game, which is valid execution.
                        console.log("[GameEngine] Time Attack Timeout -> Success/Finish");
                        this.handleMicrogameResult(true);
                    } else {
                        this.handleMicrogameResult(false); // Time out = fail
                    }
                }
            }

            if (this.currentMicrogame) {
                try {
                    this.currentMicrogame.update(dt);
                } catch (error) {
                    console.error("Error in microgame update:", error);
                    this.handleMicrogameResult(false); // Fail gracefully
                }
            }
        }
    }

    handleMicrogameResult(success) {
        // Prevent double-triggering (e.g. timeout AND win)
        if (this.state !== 'PLAYING') return;

        // Cleanup the current game immediately so it doesn't stay on screen during transition
        if (this.currentMicrogame) {
            this._lastMicrogameClass = this.currentMicrogame.constructor;
            this.currentMicrogame.cleanup();
            this.currentMicrogame = null;
        }

        // --- DISPATCHER ---
        if (this.isChallengeMode || this.gameMode === 'CHALLENGE' || this.activeChallenge) {
            this.handleChallengeRoundEnd(success);
        } else {
            this.handleStandardRoundEnd(success); // Standard & Infinite
        }
    }

    handleVersusRoundEnd() {
        this.showNotification('Versus mode removed from PixelBlob.');
        this.quitGame();
    }

    handleChallengeRoundEnd(success) {
        // Special Handling for Score Attack / Single Game Infinite
        // If we are in stored 'score attack' mode (detected below), we don't want to count "rounds won", 
        // we want the raw score from the game.

        const forceSurvivalIds = [
            'c19_locksmith', 'c20_hacker', 'c16_eagle_eye', 'c08_orbital', 'c06_math_whiz', 'c01_tap_blitz',
            'c21_chrono', 'c23_perfect_fit'
        ];
        const config = this.activeChallenge.config || {};
        const isSurvival = config.survival === true || (this.activeChallenge && forceSurvivalIds.includes(this.activeChallenge.id));

        let isScoreAttack = !this.isGlobalInfinite && this.activeChallenge.mode === 'infinite' && this.activeChallenge.gameClass && !isSurvival;

        if (success) {
            if (!isScoreAttack) {
                this.score++; // Standard mode: Score = rounds survived
            }
            // Else: Score is presumed to be handled by the specific microgame logic directly on engine.score,
            // OR we should capture it here if the microgame exposes it.
            // For now, assuming existing logic holds (microgames like Whack usually update engine.score).

            // COIN FIX: Always increment roundsWon for coin rewards
            this.roundsWon++;
            if (this.roundsWon % 5 === 0) {
                if (this.authManager.currentUser) this.authManager.currentUser.coins++;
                this.updateHUD();
            }

            this.challengesCompleted++;

            // Determine Win Condition
            let challengeWon = false;

            if (this.activeChallenge.mode === 'infinite' || this.activeChallenge.mode === 'infinite_no_timer') {
                // Infinite Mode: Usually play until failure.
                // EXCEPTION: "Time Attack" / "Score Attack" on a SINGLE game (like Speed Sort / Whack).
                // If it's a single game challenge (not global random) AND we just finished a round successfully (Timeout or Win),
                // we should probably END the challenge if it was time-based.

                // How to detect Time Attack? 
                // If the microgame has a fixed duration (timeout) and returns success on timeout (like Whack/Sort),
                // then "success" passes here.

                // If we are in "infinite" mode, standard behavior is "Next Round".
                // But for Whack/Sort, "Next Round" is just resetting.
                // User wants: Stop at end of time.

                // Heuristic: If it's NOT the Global Infinite (which rotates games) AND success is true...
                if (!this.isGlobalInfinite && this.activeChallenge.gameClass) {
                    // It's a specific game challenge.
                    // If it was a "Timeout" win (implied by success in infinite), we should end?
                    // Let's assume YES for now: If you survive the duration of a Single Game Infinite Challenge, you WIN/FINISH.
                    challengeWon = true;
                } else {
                    challengeWon = false; // Continue looping for Global or pure survival
                }
            } else if (this.activeChallenge.mode === 'streak') {
                if (this.challengesCompleted >= this.challengeTarget) {
                    console.log(`[GameEngine] Streak Target Reached: ${this.challengesCompleted} >= ${this.challengeTarget}`);
                    challengeWon = true;
                }
            } else {
                // Single Mode: One win is enough
                console.log(`[GameEngine] Single Mode End (Default).`);
                challengeWon = true;
            }

            // EMERGENCY SAFETY BYPASS
            // Force these to NEVER win (aka loop forever)
            const forceLoopIds = [
                'c19_locksmith', 'c20_hacker', 'c16_eagle_eye', 'c08_orbital', 'c06_math_whiz', 'c01_tap_blitz',
                'c21_chrono', 'c23_perfect_fit'
            ];
            if (this.activeChallenge && forceLoopIds.includes(this.activeChallenge.id)) {
                console.log(`[GameEngine] Emergency Loop enforced for ${this.activeChallenge.id}`);
                challengeWon = false;
            }

            console.log(`[GameEngine] Round Result -> ChallengeWon: ${challengeWon}`);

            if (challengeWon) {
                this.finishChallenge(true); // Success finish
                return;
            }

            // If not won yet (Infinity or uncompleted Streak), continue:
            // If not won yet, continue the challenge
            console.log("✅ Round Won! New Score:", this.score);
            this.roundsWon++;
            if (this.roundsWon % 5 === 0) {
                if (this.authManager.currentUser) this.authManager.currentUser.coins++;
                this.updateHUD();
            }
            this.speedMultiplier += 0.1;
            // this.authManager.earnCoins(1); // Server handles total calculation now
            this.updateHUD();
            this.nextRound();
        } else {
            this.lives--;
            this.showLoseLifeAnimation();
            if (this.lives <= 0) {
                this.finishChallenge(false);
                return;
            }
            this.updateHUD();
            this.nextRound();
        }
    }

    handleStandardRoundEnd(success) {
        // Standard & Infinite Logic
        if (this.gameMode === 'INFINITE') {
            if (success) {
                // Score is Time-Based, do not increment.
                this.roundsWon++;
                if (this.roundsWon % 5 === 0) {
                    if (this.authManager.currentUser) this.authManager.currentUser.coins++;
                    this.updateHUD();
                }
                // Speed increases
                this.speedMultiplier = Math.min(this.speedMultiplier + 0.1, this.maxSpeed);
                // this.authManager.earnCoins(1); // Server handles total calculation now
                this.updateHUD();
                this.nextRound();
            } else {
                this.lives--; // Lose a life
                this.showLoseLifeAnimation();
                console.warn(`[GameEngine] Infinite Mode Round Failed. Lives: ${this.lives}`);

                const lastGameClass = this._lastMicrogameClass;
                const resumeGame = () => {
                    if (this.lives <= 0) {
                        this.checkRevive();
                    } else {
                        this.updateHUD();
                        this.nextRound();
                    }
                };

                if (lastGameClass) {
                    if (this._shouldShowLossTutorial(lastGameClass)) {
                        // Show tutorial (solution) on first loss for this game only.
                        this._markLossTutorialShown(lastGameClass);
                        this.state = 'PAUSED';
                        this.tutorialManager.showWithPlayback(lastGameClass, resumeGame, null, {
                            hideClose: true,
                            showDontShowAgain: true,
                            disableStorageKey: this._getLossTutorialStorageKey(lastGameClass)
                        });
                    } else {
                        resumeGame();
                    }
                } else {
                    resumeGame();
                }
            }
            return;
        }

        // Standard Mode
        if (success) {
            // Score is Time-Based, do not increment.
            this.roundsWon++;
            if (this.roundsWon % 5 === 0) {
                if (this.authManager.currentUser) this.authManager.currentUser.coins++;
                this.updateHUD();
            }
            // this.authManager.earnCoins(1); // Server handles total calculation now
            // this.authManager.earnXp(1); // Server handles total calculation now
            // TODO: Play success sound/effect
        } else {
            this.lives--;
            this.showLoseLifeAnimation();
            if (this.lives <= 0) {
                this.checkRevive(); // Check revive before Game Over
                this.updateHUD();
                return; // Stop flow
            }
            // TODO: Play fail sound/effect
        }
        this.updateHUD();
        this.nextRound();
    }

    _getLossTutorialStorageKey(GameClass) {
        const gameName = GameClass?.name || 'unknown_game';
        return `pixelblob_loss_tutorial_seen_${gameName}`;
    }

    _shouldShowLossTutorial(GameClass) {
        if (!GameClass) return false;
        return localStorage.getItem(this._getLossTutorialStorageKey(GameClass)) !== 'true';
    }

    _markLossTutorialShown(GameClass) {
        if (!GameClass) return;
        localStorage.setItem(this._getLossTutorialStorageKey(GameClass), 'true');
    }

    async finishChallenge(success) {
        // Do NOT clear activeChallenge yet to ensure gameOver checks pass if called late
        // this.activeChallenge = null; 
        this.currentMicrogame = null;
        this.state = 'CHALLENGE_COMPLETED'; // Lock state to prevent Game Over loops
        this.gameRunning = false;
        // Do NOT reset gameMode to 'Menu' here; keep it CHALLENGE so loop logic knows we are in challenge context
        // until user explicitly navigates away.

        // CALCULATE STARS
        const challenge = this.challengeManager.challenges[this.currentChallengeIndex];

        // Special Handling for Infinite Mode:
        // You always "lose" eventually, but we check if score meets goals.
        // For standard modes, you need explicit 'success' (win) to get stars.
        let isValidAttempt = success;

        if (challenge.mode === 'infinite' || challenge.mode === 'streak' || challenge.mode === 'infinite_no_timer') {
            isValidAttempt = true; // Always count the score, even if we died
        }

        let stars = 0;
        // FIX: Always use this.score. It tracks rounds in Streak/Standard-Infinite, AND tracks points/time in Custom-Infinite (Zen, Sort, Whack).
        // The previous logic forced challengesCompleted which is 0 for single-round score games.
        let score = this.score;

        // Ensure challengesCompleted is mocked if strictly needed for streak logic elsewhere, but for scoring, this.score is king.
        if (challenge.mode === 'streak' && score < this.challengesCompleted) {
            // Fallback for streak if score wasn't incremented properly? 
            // Usually score == challengesCompleted in streak.
            score = this.challengesCompleted;
        }
        // So they should be accurate.

        if (isValidAttempt) {
            challenge.goals.forEach(g => {
                if (score >= g.score) stars = Math.max(stars, g.stars);
            });
        }

        const won = stars > 0;

        console.log(`[GameEngine] Challenge Finished. Won: ${won}, Stars: ${stars}, Score: ${score}`);

        // Save Progress - ALWAYS send roundsWon for coin rewards (even on loss)
        if (won || this.roundsWon > 0) {
            // We do NOT await this to avoid UI lag, but we log the start
            console.log(`[GameEngine] Saving Challenge Result... Won: ${won}, RoundsWon: ${this.roundsWon}`);
            // Pass roundsWon as 5th argument
            this.challengeManager.completeChallenge(challenge.id, score, 0.0, won, this.roundsWon)
                .then(res => console.log("[GameEngine] Save Complete:", res))
                .catch(err => console.error("[GameEngine] Save Error:", err));
        }

        // Show Result Screen
        // We fetch explicitly by ID because the screen is dynamic and references might be stale
        const liveScreen = document.getElementById('challenge-screen');
        if (liveScreen) {
            this.showScreen(liveScreen);
            liveScreen.classList.remove('hidden');
            liveScreen.classList.add('active');
            liveScreen.style.display = ''; // Clear inline
        } else {
            console.error("[GameEngine] FATAL: Challenge Screen missing in DOM!");
            // Fallback: Rebuild it?
            this.showChallengeMenu(); // This rebuilds it
            return;
        }

        this.ui.gameover.classList.add('hidden'); // Force hide Game Over
        this.ui.gameover.classList.remove('active');
        this.ui.gameover.style.display = 'none'; // NUCLEAR OPTION

        this.showingChallengeResult = true; // Enable Result Mode (hides nav)
        this.renderChallengePage(); // Re-render to show new stars/unlocks

        if (won) {
            this.showNotification(`CHALLENGE COMPLETE! ${stars} STAR(S)!`, 4000);
            if (this.audio) this.audio.play('win');
        } else {
            if (challenge.mode === 'infinite' || challenge.mode === 'infinite_no_timer') {
                this.showNotification(`RUN ENDED. SCORE: ${score}`, 3000);
            } else {
                this.showNotification("CHALLENGE FAILED", 3000);
            }
            if (this.audio) this.audio.play('lose');
        }

        // SCORCHED EARTH UI Fix
        this.ui.hud.classList.add('hidden'); // Ensure HUD is hidden to prevent overlap
        this.quitBtn.classList.add('hidden'); // Hide global quit button (redundant with result screen exit)
        const screens = document.querySelectorAll('.screen');
        screens.forEach(s => {
            if (s.id !== 'challenge-screen') s.classList.add('hidden');
        });

        // Ensure canvas loop continues (for particle effects if any, or just to keep engine alive)
        // But preventing it from drawing over UI
        requestAnimationFrame((t) => this.loop(t));
    }

    checkRevive() {
        console.log(`[GameEngine] checkRevive called. Lives: ${this.lives}, ReviveCount: ${this.reviveCount}`);

        // CHALLENGE MODE: No Revives allowed (prevents Infinite Mode feel)
        if (this.isChallengeMode || this.activeChallenge || this.gameMode === 'CHALLENGE') {
            console.warn("[GameEngine] Revive disabled in Challenge Mode. Finishing...");
            this.finishChallenge(false);
            return;
        }

        // Allow revive in Standard Mode as well
        if (this.reviveCount < 2) {
            const cost = (this.reviveCount + 1) * 10; // 10, then 20
            this.ui.reviveCost.textContent = cost;
            this.currentReviveCost = cost;

            // Show Overlay
            this.state = 'REVIVE'; // Pause state
            this.ui.reviveOverlay.classList.remove('hidden');
            this.ui.reviveOverlay.classList.add('active');
        } else {
            console.warn("[GameEngine] No revives left. Triggering Game Over.");
            this.gameOver();
        }
    }

    async attemptRevive() {
        if (this.authManager.canAfford(this.currentReviveCost)) {
            // Deduct coins using new spend method
            await this.authManager.spendCoins(this.currentReviveCost, 'revive');

            this.reviveCount++;


            this.lives = 1; // Restore 1 life in Infinite/Sudden Death

            this.ui.reviveOverlay.classList.add('hidden');
            this.ui.reviveOverlay.classList.remove('active');

            // Resume
            this.updateHUD();
            this.nextRound();
        } else {
            this.showNotification("Not enough coins!");
            this.cancelRevive();
        }
    }

    cancelRevive() {
        this.ui.reviveOverlay.classList.add('hidden');
        this.ui.reviveOverlay.classList.remove('active');
        this.gameOver();
    }

    showLoseLifeAnimation() {
        const overlay = document.getElementById('lose-life-overlay');
        overlay.classList.add('active');
        setTimeout(() => {
            overlay.classList.remove('active');
        }, 500);
    }

    updateHUD() {
        const scoreEl = document.getElementById('score');
        if (scoreEl) scoreEl.textContent = this.score;
        else if (this.ui.score) this.ui.score.textContent = this.score;
        // Use Neon Hearts
        const heartSvg = Icons.heart(16, 'var(--secondary-color)');
        const hearts = Array(Math.max(0, this.lives)).fill(`<span class="neon-heart">${heartSvg}</span>`).join(' ');
        this.ui.lives.innerHTML = hearts;

        // Update Coins
        if (this.authManager && this.authManager.currentUser) {
            const coins = this.authManager.currentUser.coins;

            if (this.ui.coinsDisplay) this.ui.coinsDisplay.textContent = coins;
            if (this.ui.menuCoinsDisplay) this.ui.menuCoinsDisplay.textContent = coins;
            if (this.ui.shopCoinsDisplay) this.ui.shopCoinsDisplay.textContent = coins;

            // Update Menu Level & XP Bar (menu only, no in-game badge)
            const level = this.authManager.currentUser.level || 1;
            const xp = this.authManager.currentUser.xp || 0;
            const xpNeeded = this.authManager.getXpForNextLevel(level);

            if (this.ui.menuLevelDisplay) {
                this.ui.menuLevelDisplay.textContent = 'LVL ' + level;
            }
            if (this.ui.menuXpFill) {
                const pct = Math.min(100, Math.max(0, (xp / xpNeeded) * 100));
                this.ui.menuXpFill.style.width = `${pct}%`;
            }

            // Update Energy Display
            if (this.ui.menuEnergyDisplay) {
                const user = this.authManager.currentUser;
                if (user.is_premium || user.energy >= 999) {
                    this.ui.menuEnergyDisplay.textContent = "∞";
                    // Hide refill bar for premium
                    const refillContainer = document.getElementById('energy-refill-container');
                    if (refillContainer) refillContainer.classList.add('hidden');
                } else {
                    const energy = user.energy !== undefined && user.energy !== null ? user.energy : 10;
                    const maxEnergy = user.maxEnergy || 10;
                    this.ui.menuEnergyDisplay.textContent = `${energy}/${maxEnergy}`;
                    // Show/update refill bar if not full
                    this.updateEnergyRefillBar(user);
                }
            }
        }
    }

    async updateEnergyRefillBar(user) {
        const refillContainer = document.getElementById('energy-refill-container');
        const refillFill = document.getElementById('energy-refill-fill');
        const refillText = document.getElementById('energy-refill-text');
        if (!refillContainer || !refillFill || !refillText) return;

        // Stop any previous ticker
        if (this._energyTickInterval) {
            clearInterval(this._energyTickInterval);
            this._energyTickInterval = null;
        }

        if (user.energy >= (user.maxEnergy || 5)) {
            refillContainer.classList.add('hidden');
            return;
        }

        refillContainer.classList.remove('hidden');

        // Fetch refill status from server ONCE
        try {
            const res = await this.authManager.db.authenticatedFetch('/economy/energy');
            const data = await res.json();

            if (data.full || data.current >= (data.max || 5)) {
                refillContainer.classList.add('hidden');
                return;
            }

            const REFILL_MS = 20 * 60 * 1000; // 20 minutes
            let remainingMs = data.nextIn || REFILL_MS;

            // Update display immediately
            const updateDisplay = () => {
                const elapsed = REFILL_MS - remainingMs;
                const pct = Math.min(100, Math.max(0, (elapsed / REFILL_MS) * 100));
                refillFill.style.width = `${pct}%`;

                const totalSec = Math.max(0, Math.ceil(remainingMs / 1000));
                const min = Math.floor(totalSec / 60);
                const sec = totalSec % 60;
                refillText.innerHTML = `Next <svg style="width:10px;height:10px;vertical-align:middle;fill:currentColor" viewBox="0 0 24 24"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg> in ${min}:${String(sec).padStart(2, '0')}`;
            };

            updateDisplay();

            // Tick every second
            this._energyTickInterval = setInterval(() => {
                remainingMs -= 1000;

                if (remainingMs <= 0) {
                    // Timer hit 0 — energy should have refilled, re-fetch
                    clearInterval(this._energyTickInterval);
                    this._energyTickInterval = null;

                    // Re-sync from server
                    if (this.authManager && this.authManager.currentUser) {
                        this.authManager.db.authenticatedFetch('/economy/energy')
                            .then(r => r.json())
                            .then(freshData => {
                                if (freshData.current !== undefined) {
                                    this.authManager.currentUser.energy = freshData.current;
                                    this.updateHUD(); // Will re-call updateEnergyRefillBar
                                }
                            }).catch(() => { });
                    }
                    return;
                }

                updateDisplay();
            }, 1000);

        } catch (e) {
            refillContainer.classList.add('hidden');
        }
    }

    getHighScores(key) {
        const data = localStorage.getItem(`pixelblob_lb_${key}`) || localStorage.getItem(`quicky_lb_${key}`);
        return data ? JSON.parse(data) : [];
    }

    checkHighScore(key, score) {
        const scores = this.getHighScores(key);
        if (scores.length < 10) return true;
        return score > scores[scores.length - 1].score;
    }

    saveHighScore(key, name, score, url) {
        // CHALLENGE MODE: Do NOT save high scores to global rankings
        if (this.gameMode === 'CHALLENGE' || this.gameMode === 'INFINITE') {
            return;
        }

        const scores = this.getHighScores(key);
        scores.push({ name, score, url });
        scores.sort((a, b) => b.score - a.score);
        if (scores.length > 10) scores.pop(); // Keep Top 10

        localStorage.setItem(`pixelblob_lb_${key}`, JSON.stringify(scores));
        localStorage.setItem(`quicky_lb_${key}`, JSON.stringify(scores));
    }

    handleShare() {
        if (!this.authManager) return;
        const score = this.score;
        const code = this.authManager.getFriendCode() || "UNKNOWN";
        const text = `I scored ${score} in PixelBlob! My Code: ${code} #PixelBlob`;

        const copyFallback = (str) => {
            const el = document.createElement('textarea');
            el.value = str;
            el.setAttribute('readonly', '');
            el.style.position = 'absolute';
            el.style.left = '-9999px';
            document.body.appendChild(el);
            el.select();
            try {
                document.execCommand('copy');
                this.showNotification("Score & Code copied to clipboard!");
            } catch (e) {
                prompt("Copy manually:", str);
            }
            document.body.removeChild(el);
        };

        if (navigator.share) {
            navigator.share({
                title: 'Quicky Game',
                text: text,
                url: window.location.href
            }).catch(console.error);
        } else {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(text).then(() => {
                    this.showNotification("Score & Code copied to clipboard!");
                }).catch(() => copyFallback(text));
            } else {
                copyFallback(text);
            }
        }
    }





    loop(timestamp) {
        if (!this.lastFrameTime) {
            this.lastFrameTime = timestamp;
        }

        // SAFETY NET: Ensure Challenge Mode flags don't disappear
        if (this.activeChallenge && (!this.isChallengeMode || this.gameMode !== 'CHALLENGE')) {
            // Only restore if we are NOT in 'CHALLENGE_COMPLETED' state (to avoid loop)
            if (this.state !== 'CHALLENGE_COMPLETED') {
                console.warn("[GameEngine] Restoring lost Challenge Mode flags in loop.");
                this.isChallengeMode = true;
                this.gameMode = 'CHALLENGE';
            }
        }

        let dt = timestamp - this.lastFrameTime;
        this.lastFrameTime = timestamp;

        // CLAMP DT: Prevent huge time jumps (e.g. tab switching) triggering instant timeout
        if (dt > 100) {
            console.warn(`[GameEngine] Large dt detected: ${dt} ms. Clamping to 100ms.`);
            dt = 100;
        }

        if (!this.gameRunning && this.state !== 'TRANSITION') {
            // If game is stopped and not transitioning, do not process update.
            // But continue requesting animation frame to keep UI alive if needed (e.g. particles), 
            // OR just return if we want to stop engine overhead. 
            // For now, let's just skip update logic.
        } else {
            this.update(dt);
        }

        requestAnimationFrame((t) => this.loop(t));
    }

    showChallengeMenu() {
        console.log("[GameEngine] showChallengeMenu v3.5 Start");
        this.gameMode = 'Menu';
        this.isChallengeMode = false; // Exit Challenge Mode context
        this.hideAllScreens();

        if (typeof this.currentChallengeIndex === 'undefined') {
            this.currentChallengeIndex = 0;
        }

        const uiLayer = document.getElementById('ui-layer');
        if (!uiLayer) {
            console.error("[GameEngine] FATAL: #ui-layer not found!");
            return;
        }

        // 1. CLEANUP: Remove any existing old screens to prevent duplicates/ghosts
        const oldScreen = document.getElementById('challenge-screen');
        if (oldScreen) {
            console.log("[GameEngine] Removing old challenge screen...");
            oldScreen.remove();
        }

        // 2. CREATE FRESH STRUCTURE (Manual Elements)
        console.log("[GameEngine] Building New UI...");

        const screen = document.createElement('div');
        screen.id = 'challenge-screen';
        screen.className = 'screen'; // Visible by default, hide logic handles others

        // Header
        const h2 = document.createElement('h2');
        h2.textContent = this.i18n.t('challenges.runTitle');
        screen.appendChild(h2);

        // Container (The crucial part)
        const container = document.createElement('div');
        container.id = 'challenge-container';
        // Add overflow handling and remove rigid alignment that causes overlap/clipping
        container.style.cssText = "flex: 1; display: flex; flex-direction: column; width: 100%; min-height: 200px; overflow-y: auto; overflow-x: hidden; position: relative;";
        screen.appendChild(container); // Append DIRECTLY to screen

        // Navigation
        const navDiv = document.createElement('div');
        navDiv.className = 'challenge-nav';
        navDiv.style.cssText = "display: flex; gap: 20px; align-items: center; justify-content: center; margin-bottom: 20px;";

        const prevBtn = document.createElement('button');
        prevBtn.id = 'challenge-prev-btn';
        prevBtn.className = 'neon-btn small';
        prevBtn.textContent = 'PREV';
        prevBtn.onclick = () => this.navChallenge(-1);
        navDiv.appendChild(prevBtn);

        const indicator = document.createElement('div');
        indicator.id = 'challenge-page-indicator';
        indicator.textContent = 'init / init';
        indicator.style.cssText = "font-family: var(--font-main); color: var(--secondary-color);";
        navDiv.appendChild(indicator);

        const nextBtn = document.createElement('button');
        nextBtn.id = 'challenge-next-btn';
        nextBtn.className = 'neon-btn small';
        nextBtn.textContent = 'NEXT';
        nextBtn.onclick = () => this.navChallenge(1);
        navDiv.appendChild(nextBtn);

        screen.appendChild(navDiv);

        // Back Button
        const backBtn = document.createElement('button');
        backBtn.id = 'challenge-back-btn';
        backBtn.className = 'neon-btn';
        backBtn.style.marginBottom = '20px';
        backBtn.textContent = this.i18n.t('challenges.backToMenu');
        backBtn.onclick = () => {
            screen.classList.add('hidden');
            const pm = document.getElementById('play-mode-screen');
            if (pm) pm.classList.remove('hidden');
        };
        screen.appendChild(backBtn);

        // 3. INJECT INTO DOM
        uiLayer.appendChild(screen);

        // 4. BIND & VERIFY
        this.ui.challengeScreen = screen;
        this.ui.challengeContainer = container; // We have the direct reference!
        this.ui.challengePageIndicator = indicator;
        this.ui.challengePrevBtn = prevBtn;
        this.ui.challengeNextBtn = nextBtn;
        this.ui.challengeNavDiv = navDiv;
        this.ui.challengeFolderBackBtn = backBtn;

        this.showingChallengeResult = false; // Default to browsing mode

        console.log("[GameEngine] UI Built. Container:", this.ui.challengeContainer);

        // 5. RENDER
        this.ui.challengeScreen.classList.remove('hidden');
        this.renderChallengePage();
        this.challengeManager.fetchProgress().then(() => {
            // Auto-navigate to latest unlocked challenge
            const challenges = this.challengeManager.challenges;
            if (challenges && challenges.length > 0) {
                let maxUnlocked = 0;
                for (let i = 0; i < challenges.length; i++) {
                    if (i === 0) continue;
                    // Challenge i is unlocked if i-1 has stars (or if we logic it differently in render)
                    const prevStars = this.challengeManager.getStarCount(challenges[i - 1].id);
                    if (prevStars > 0) {
                        maxUnlocked = i;
                    } else {
                        break;
                    }
                }
                console.log("Auto-navigating to latest unlocked challenge:", maxUnlocked);
                this.currentChallengeIndex = maxUnlocked;
            }
            this.renderChallengePage();
        });
    }

    navChallenge(dir) {
        const challenges = this.challengeManager.challenges;
        const newIndex = this.currentChallengeIndex + dir;

        // Bounds Check
        if (newIndex < 0 || newIndex >= challenges.length) return;

        // Lock Check (Prevent going Next if current not cleared? Or prevent going to Locked page?)
        // Let's implement: Can only go Next if current page is cleared (>= 1 star) OR if we are just browsing back to an already unlocked page.
        // Better: We track "max unlocked index".
        // Simple Logic: check if target index is unlocked.
        // Unlocking rule: Challenge N is unlocked if Challenge N-1 has >= 1 star. Challenge 0 always unlocked.

        if (dir > 0) {
            const currentChallenge = challenges[this.currentChallengeIndex];
            const stars = this.challengeManager.getStarCount(currentChallenge.id);
            // If we are at the "furthest" point, we need stars to proceed
            // Actually, we can just check if *target* is unlocked.
            // But we simulate "unlock next page" visually.

            // Allow navigation if we have stars on CURRENT, OR if we are re-visiting (e.g. at index 0, max index 5).
            // Simplest: Calculate Max Unlocked Index.
            let maxUnlocked = 0;
            for (let i = 0; i < challenges.length; i++) {
                if (i === 0) continue;
                const prevStars = this.challengeManager.getStarCount(challenges[i - 1].id);
                if (prevStars > 0) maxUnlocked = i;
                else break;
            }

            if (newIndex > maxUnlocked) {
                // Locked! Shake effects?
                this.ui.challengeNextBtn.classList.add('shake');
                setTimeout(() => this.ui.challengeNextBtn.classList.remove('shake'), 400);
                return;
            }
        }

        this.currentChallengeIndex = newIndex;
        this.renderChallengePage();
    }

    renderChallengePage() {
        console.log("--- DEBUG RENDER CHALLENGE PAGE ---");
        console.log(`Index: ${this.currentChallengeIndex} `);

        if (!this.ui.challengeContainer) {
            console.error("UI Container Missing! Attempting re-bind...");
            this.ui.challengeContainer = document.getElementById('challenge-container');
            if (!this.ui.challengeContainer) {
                console.error("Still missing UI container. Abort.");
                return;
            }
        }

        this.ui.challengeContainer.innerHTML = '';

        if (!this.challengeManager) {
            console.error("ChallengeManager is undefined!");
            this.ui.challengeContainer.innerHTML = '<div style="color:red">Error: Manager Missing</div>';
            return;
        }

        // TOGGLE MODES: Result vs Browsing
        const isResultMode = this.showingChallengeResult;
        if (this.ui.challengeNavDiv) this.ui.challengeNavDiv.style.display = isResultMode ? 'none' : 'flex';
        // Note: challengeFolderBackBtn might likely be null if we haven't rebound it correctly or checking wrong property
        if (this.ui.challengeFolderBackBtn) this.ui.challengeFolderBackBtn.style.display = isResultMode ? 'none' : 'block';
        if (this.ui.challengePageIndicator) this.ui.challengePageIndicator.style.display = isResultMode ? 'none' : 'block';

        const challenges = this.challengeManager.challenges;
        if (!challenges || challenges.length === 0) {
            console.warn("Challenge List is Empty!");
            this.ui.challengeContainer.innerHTML = '<div style="color:gray">No Challenges Loaded.</div>';
            return;
        }

        // Clamp Index
        if (this.currentChallengeIndex < 0) this.currentChallengeIndex = 0;
        if (this.currentChallengeIndex >= challenges.length) this.currentChallengeIndex = challenges.length - 1;

        const c = challenges[this.currentChallengeIndex];
        console.log("Rendering Challenge:", c.name);

        // Update Indicator
        if (this.ui.challengePageIndicator) {
            this.ui.challengePageIndicator.textContent = `${this.currentChallengeIndex + 1} / ${challenges.length}`;
        }

        // Get Status
        const stars = this.challengeManager.getStarCount(c.id);

        let starsHtml = '';
        for (let i = 0; i < 3; i++) {
            const isFilled = i < stars;
            const starSvg = Icons.star(24, isFilled ? 'var(--accent-color)' : '#333');
            starsHtml += `<span class="neon-star ${isFilled ? 'filled' : 'empty'}" style="filter: ${isFilled ? 'drop-shadow(0 0 5px var(--accent-color))' : 'none'};">${starSvg}</span>`;
        }

        const isCompleted = stars > 0;

        // Render Large Card
        const div = document.createElement('div');
        div.className = 'challenge-card-large';
        div.style.position = 'relative'; // Ensure stacking context
        div.style.margin = 'auto'; // Center safely within scrollable container
        if (this.showingChallengeResult) {
            div.style.border = '2px solid gold'; // Special styling for result?
            div.style.boxShadow = '0 0 20px rgba(255, 215, 0, 0.3)';
        }
        div.innerHTML = `
            <div class="challenge-header">
                <div class="challenge-number">#${this.currentChallengeIndex + 1}</div>
                <div class="challenge-stars">${starsHtml}</div>
                <button class="icon-btn challenge-exit-btn" style="position: absolute; top: 10px; right: 10px; width: 30px; height: 30px; font-size: 1rem; background: rgba(0,0,0,0.5);">✕</button>
            </div>
            
            <div class="challenge-icon" style="text-align: center;">
                 <!-- Centered Large Stars -->
                 <div class="challenge-stars-display" style="display:flex; justify-content:center; gap:10px;">
                    <style>
                        .challenge-stars-display .neon-star { font-size: 3.5rem !important; text-shadow: 0 0 15px var(--primary-color); }
                    </style>
                    ${starsHtml}
                </div>
            </div> 

            <div class="challenge-title">${c.name}</div>
            <div class="challenge-desc">${c.description}</div>
            
            <div style="text-align:center; font-size: 1.2rem; margin-bottom: 5px; color: var(--secondary-color); font-family: var(--font-main);">
                ${this.showingChallengeResult ? `<div>RUN SCORE: <span style="font-weight:bold; color:var(--primary-color);">${((c.mode === 'streak' || c.mode === 'infinite' || c.mode === 'infinite_no_timer') && !(c.gameClass && !this.isGlobalInfinite)) ? this.challengesCompleted : this.score}</span></div>` : ''}
                BEST SCORE: <span style="font-weight:bold; color:#fff;">${this.challengeManager.getBestScore(c.id)}</span>
            </div>

            <div class="challenge-goals">
                ${this.renderChallengeGoals(c)}
            </div>
            <button class="neon-btn play-challenge-btn" style="margin-top: 20px; width: 100%;">
                ${this.showingChallengeResult ? 'REPLAY' : 'PLAY'}
            </button>
        `;

        const btn = div.querySelector('.play-challenge-btn');
        if (btn) {
            btn.addEventListener('click', () => {
                console.log("Play Button Clicked for:", c.name);
                this.startChallenge(c);
            });
        }

        const exitBtn = div.querySelector('.challenge-exit-btn');
        if (exitBtn) {
            exitBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                if (this.showingChallengeResult) {
                    // Close Result View -> Go to Browsing
                    this.showingChallengeResult = false;
                    this.renderChallengePage();
                } else {
                    // Close Browsing -> Go back to Play Mode Screen
                    this.ui.challengeScreen.classList.add('hidden');
                    document.getElementById('play-mode-screen').classList.remove('hidden');
                }
            });
        }

        this.ui.challengeContainer.appendChild(div);

        // --- BUTTON STATE LOGIC ---
        // Calc Max Unlocked
        let maxUnlocked = 0;
        for (let i = 0; i < challenges.length; i++) {
            if (i === 0) continue;
            // Challenge i is unlocked if i-1 has stars
            const prevStars = this.challengeManager.getStarCount(challenges[i - 1].id);
            if (prevStars > 0) maxUnlocked = i;
            else break; // Logic stops at first unfinished chain
        }
        console.log(`Max Unlocked Index: ${maxUnlocked}, Current: ${this.currentChallengeIndex}`);

        if (this.ui.challengePrevBtn) {
            this.ui.challengePrevBtn.disabled = this.currentChallengeIndex === 0;
            this.ui.challengePrevBtn.style.opacity = this.currentChallengeIndex === 0 ? '0.3' : '1';
        }

        if (this.ui.challengeNextBtn) {
            const isLastPage = this.currentChallengeIndex >= challenges.length - 1;
            // Can go next if we are strictly less than maxUnlocked.
            // OR if current challenge itself is completed (unlocking the NEXT one instantly)
            // The loop above calculates maxUnlocked based on PREVIOUS.
            // So if I am at I=0 (max=0), and complete it, loop won't see it until re-render?
            // challengeManager.getStarCount is live.
            // So if I have stars on 0, maxUnlocked becomes 1.
            // If I am at 0, 0 < 1 is true. YES.

            const canGoNext = !isLastPage && (this.currentChallengeIndex < maxUnlocked);

            this.ui.challengeNextBtn.disabled = !canGoNext;
            this.ui.challengeNextBtn.style.opacity = canGoNext ? '1' : '0.3';
            this.ui.challengeNextBtn.innerHTML = canGoNext ? 'NEXT' : (isLastPage ? 'END' : `LOCKED ${Icons.lock(14, '#666')}`);
        }
    }

    renderChallengeGoals(challenge) {
        if (challenge.mode === 'streak') {
            return `<div class="goal-row">Streak Target: <span style="color:var(--primary-color)">${challenge.streakTarget}</span></div>`;
        }
        return challenge.goals.map((g, i) => {
            // Logic: If user has > i stars, this row is "done"
            const isDone = this.challengeManager.getStarCount(challenge.id) > i;

            // Render stars for this row (e.g. 1 star for 1st row, 2 for 2nd...)
            let rowStars = '';
            for (let k = 0; k <= i; k++) {
                const s = Icons.star(14, isDone ? 'var(--accent-color)' : '#444');
                rowStars += `<span class="neon-star ${isDone ? 'filled' : 'empty'}" style="font-size:1rem; ${isDone ? 'filter:drop-shadow(0 0 3px var(--accent-color));' : ''}">${s}</span>`;
            }

            return `
            <div class="goal-row" style="opacity: ${isDone ? '1' : '0.7'}">
                <span style="display:flex; gap:2px;">${rowStars}</span>
                <span style="${isDone ? 'color:#fff; text-shadow:0 0 5px var(--primary-color);' : ''}">${g.label}</span>
            </div>
        `}).join('');
    }

    async startChallenge(challenge) {
        // ENERGY CHECK
        if (this.authManager && this.authManager.currentUser) {
            const energyResult = await this.authManager.startGame(); // Deduct 1 Energy
            if (!energyResult.success) {
                const energyIcon = Icons.energy(20, 'var(--secondary-color)');
                if (await this.showConfirm(`NO ENERGY LEFT! ${energyIcon}\n\nVisit Shop for Energy?`)) {
                    this.showSkinsMenu();
                }
                return;
            }
            this.updateHUD();
        }

        console.log("Starting challenge:", challenge.name, "GameClass:", challenge.gameClass);
        this.activeChallenge = challenge;
        this.gameMode = 'CHALLENGE';
        this.isChallengeMode = true; // Robust Flag
        this.score = 0;
        this.reviveCount = 0;
        this.lives = challenge.lives || 1;
        this.challengesCompleted = 0;
        this.roundsWon = 0; // FIX: Ensure roundsWon is initialized

        // SCORCHED EARTH: Force hide all screens manually
        const screens = document.querySelectorAll('.screen');
        screens.forEach(s => {
            s.classList.add('hidden');
            s.classList.remove('active');
        });

        this.hideAllScreens();

        // Show HUD & Quit Button
        this.ui.hud.classList.remove('hidden');
        this.quitBtn.classList.remove('hidden');

        // Initialize HUD with correct score/lives
        this.updateHUD();

        // Reset Speed
        this.speedMultiplier = 1.0;

        // Setup Next Game with Safety Check
        this.nextGameClass = challenge.gameClass;
        if (!this.nextGameClass) {
            console.error("Challenge Game Class is Undefined! Defaulting to TapGame.");
            this.nextGameClass = this.gamesList[0].class; // Fallback
        } else {
            console.log("Next Game Class set to:", this.nextGameClass.name);
        }

        if (challenge.mode === 'streak') {
            // Use DB Value or reasonable default for new challenges
            this.challengeTarget = challenge.streakTarget || 15;
        } else {
            this.challengeTarget = 1;
        }

        console.log(`[GameEngine] Challenge Started: ${challenge.name}. Mode: ${challenge.mode}, Target: ${this.challengeTarget}, Config:`, challenge.config);

        // Add Transition for better UX and state stability
        this.state = 'TRANSITION';
        this.ui.transition.classList.remove('hidden');
        this.ui.transition.classList.add('active');
        this.ui.instruction.innerHTML = `CHALLENGE<br><span style="font-size: 0.8em; color: var(--primary-color)">${challenge.name}</span>`;

        const startDelay = (challenge.mode === 'infinite_no_timer') ? 500 : 1500;
        this.transitionTimeout = setTimeout(() => {
            this.ui.transition.classList.add('hidden');
            this.ui.transition.classList.remove('active');
            this.startMicrogame();
        }, startDelay);
    }
    hideAllScreens() {
        const screens = document.querySelectorAll('.screen');
        screens.forEach(s => {
            s.classList.add('hidden');
            s.classList.remove('active');
        });
    }

    showScreen(id) {
        this.hideAllScreens();
        const screen = document.getElementById(id);
        if (screen) {
            screen.classList.remove('hidden');
            screen.classList.add('active');
        } else {
            console.warn(`[GameEngine] Screen not found: ${id}`);
        }
    }

    showVersusResults() {
        this.showNotification('Versus mode removed from PixelBlob.');
        this.showMainMenu();
    }
}

